/* v2026-04-13d: body_html removed, stopwords, GA4, mobile sort */
console.log('[TS-SEARCH] v2026-04-13d loaded');
/**
 * Typesense Search Page - Ersetzt Shopify Suchergebnisse.
 * HTML-Struktur exakt wie im Theme (product-card.liquid, facets-desktop.liquid, pagination.liquid).
 */

const AI_REWRITE_URL = 'https://ai-advisor.markenkoffer.de/rewrite';

// GA4 Tracking läuft vollständig über Shopify Custom Pixel (GTM-NMQKXLPG).
// Keine eigenen gtag/dataLayer Calls im Theme — siehe .claude/rules/ga4-tracking.md

/**
 * Erkennt ob eine Query natuerliche Sprache ist (nicht nur Keywords).
 * Signale: Praepositionen, Fragewörter, Zeitangaben, >3 Wörter mit Stoppwörtern.
 */
function isNLQuery(query) {
  const q = query.toLowerCase().trim();
  const words = q.split(/\s+/);
  if (words.length < 3) return false;
  // Prepositions, question words, temporal terms that signal intent
  const nlSignals = /\b(für|fuer|zum|zur|mit|ohne|bis|auf|unter|über|ueber|welch|was|wie|wo|wann|suche|brauche|möchte|moechte|wochen?|tage?|urlaub|reise|ferien|leicht|gross|große|klein|günstig|guenstig|beste|bester|bestes|empfehlung)\b/i;
  return nlSignals.test(q);
}

/**
 * Ruft den AI Rewriter auf: natuerliche Sprache -> optimierte Typesense Parameter.
 * Timeout 2s, bei Fehler wird die Original-Query zurueckgegeben.
 */
async function aiRewriteQuery(query, language) {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 4000);
    const resp = await fetch(AI_REWRITE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query, language }),
      signal: controller.signal,
    });
    clearTimeout(timeout);
    if (!resp.ok) return null;
    const data = await resp.json();
    console.log('AI Rewrite:', query, '->', JSON.stringify(data));
    return data; // { q, filter_by, sort_by }
  } catch (e) {
    console.warn('AI rewrite failed, using original query:', e.message);
    return null;
  }
}

const TS_PAGE = {
  host: 'iwmzu7e9k26dgj0vp-1.a1.typesense.net',
  port: 443,
  protocol: 'https',
  searchKey: 'c8xsK3LNFjkphH3sQNhM3yZq9yAHWnzK',
  collection: `products_${(window.ISO_CODE || 'DE').toLowerCase()}`,
};

const TS_LANG = (window.ISO_CODE || 'DE').toLowerCase();
const HAS_EMBEDDING_PAGE = TS_LANG === 'de';

const FACET_LABELS_I18N = {
  de: { vendor:'Marke', product_type:'Produkttyp', suchfarbe:'Farbe', groesse_gruppe:'Gepäckgröße', material:'Material', gender:'Geschlecht', rabatt_gruppe:'Rabatt', custom_status:'Status', on_sale:'Sale', price:'Preis', vortasche:'Mit Vortasche', rollensystem:'Rollensystem', gepaeckart:'Gepäckart', gewicht_gruppiert:'Gewicht', volumen_gruppiert:'Volumen', ausstattung:'Ausstattung', serie:'Serie', themenbereich:'Themenbereich' },
  en: { vendor:'Brand', product_type:'Product Type', suchfarbe:'Color', groesse_gruppe:'Luggage Size', material:'Material', gender:'Gender', rabatt_gruppe:'Discount', custom_status:'Status', on_sale:'Sale', price:'Price', vortasche:'Front Pocket', rollensystem:'Wheel System', gepaeckart:'Luggage Type', gewicht_gruppiert:'Weight', volumen_gruppiert:'Volume', ausstattung:'Features', serie:'Series', themenbereich:'Category' },
  fr: { vendor:'Marque', product_type:'Type de produit', suchfarbe:'Couleur', groesse_gruppe:'Taille bagage', material:'Matière', gender:'Genre', rabatt_gruppe:'Réduction', custom_status:'Statut', on_sale:'Promo', price:'Prix', vortasche:'Poche avant', rollensystem:'Système de roues', gepaeckart:'Type de bagage', gewicht_gruppiert:'Poids', volumen_gruppiert:'Volume', ausstattung:'Équipement', serie:'Série', themenbereich:'Catégorie' },
  it: { vendor:'Marca', product_type:'Tipo prodotto', suchfarbe:'Colore', groesse_gruppe:'Dimensione bagaglio', material:'Materiale', gender:'Genere', rabatt_gruppe:'Sconto', custom_status:'Stato', on_sale:'Saldi', price:'Prezzo', vortasche:'Tasca frontale', rollensystem:'Sistema ruote', gepaeckart:'Tipo bagaglio', gewicht_gruppiert:'Peso', volumen_gruppiert:'Volume', ausstattung:'Dotazione', serie:'Serie', themenbereich:'Categoria' },
  es: { vendor:'Marca', product_type:'Tipo de producto', suchfarbe:'Color', groesse_gruppe:'Tamaño equipaje', material:'Material', gender:'Género', rabatt_gruppe:'Descuento', custom_status:'Estado', on_sale:'Oferta', price:'Precio', vortasche:'Bolsillo frontal', rollensystem:'Sistema de ruedas', gepaeckart:'Tipo de equipaje', gewicht_gruppiert:'Peso', volumen_gruppiert:'Volumen', ausstattung:'Equipamiento', serie:'Serie', themenbereich:'Categoría' },
  nl: { vendor:'Merk', product_type:'Producttype', suchfarbe:'Kleur', groesse_gruppe:'Bagagemaat', material:'Materiaal', gender:'Geslacht', rabatt_gruppe:'Korting', custom_status:'Status', on_sale:'Sale', price:'Prijs', vortasche:'Voorvak', rollensystem:'Wielensysteem', gepaeckart:'Bagagetype', gewicht_gruppiert:'Gewicht', volumen_gruppiert:'Volume', ausstattung:'Uitrusting', serie:'Serie', themenbereich:'Categorie' },
};
const FACET_LABELS = FACET_LABELS_I18N[TS_LANG] || FACET_LABELS_I18N.de;

const SORT_LABELS_I18N = {
  de: ['Relevanz', 'Bestseller', 'Neueste zuerst', 'A bis Z', 'Z bis A', 'Preis (aufsteigend)', 'Preis (absteigend)'],
  en: ['Relevance', 'Bestseller', 'Newest first', 'A to Z', 'Z to A', 'Price (low to high)', 'Price (high to low)'],
  fr: ['Pertinence', 'Meilleures ventes', 'Plus récents', 'A à Z', 'Z à A', 'Prix (croissant)', 'Prix (décroissant)'],
  it: ['Rilevanza', 'Più venduti', 'Più recenti', 'A a Z', 'Z a A', 'Prezzo (crescente)', 'Prezzo (decrescente)'],
  es: ['Relevancia', 'Más vendidos', 'Más recientes', 'A a Z', 'Z a A', 'Precio (ascendente)', 'Precio (descendente)'],
  nl: ['Relevantie', 'Bestsellers', 'Nieuwste eerst', 'A tot Z', 'Z tot A', 'Prijs (laag-hoog)', 'Prijs (hoog-laag)'],
};
const _sl = SORT_LABELS_I18N[TS_LANG] || SORT_LABELS_I18N.de;
const SORT_OPTIONS = [
  { label: _sl[0], value: '_text_match:desc,boost_score:desc' },
  { label: _sl[1], value: 'boost_score:desc' },
  { label: _sl[2], value: 'published_at:desc' },
  { label: _sl[3], value: 'title:asc' },
  { label: _sl[4], value: 'title:desc' },
  { label: _sl[5], value: 'price:asc' },
  { label: _sl[6], value: 'price:desc' },
];

// Hauptprodukte (Taschen/Koffer/Schulranzen) — Zubehör wie Lunchbox, Trinkflasche,
// Nackenkissen, Schutzhülle, Wechselmotiv etc. fällt absichtlich raus und rankt
// in Vendor-Suchen unter den Hauptprodukten.
// Umbenannt (TS_PAGE_-Prefix): typesense-search.js deklariert global dieselben
// const-Namen — auf /search starben beide zusammen am Redeclare (Header-Autocomplete tot)
const TS_PAGE_MAIN_TYPES = [
  'Trolley/Koffer','Schulranzen','Schulrucksack',
  'Reisetasche','Reisetasche mit Rollen','Reisetasche ohne Rollen','Reiserucksack',
  'Rucksack','Wanderrucksack','Tagesrucksack','Trekkingrucksack','Freizeitrucksack','Kinderrucksack','Bike-Rucksack',
  'Sporttasche','Umhängetasche','Handtasche','Shopper','Clutch',
  'Aktentasche','Laptoptasche','Gürteltasche','Kulturbeutel','Beauty Case',
  'Fahrradtasche','Einkaufstrolley','Packtasche','Geldbörse',
];
const TS_PAGE_MAIN_LIST = TS_PAGE_MAIN_TYPES.map(t => '`' + t + '`').join(',');

// Gepäckart-Detection: "weichgepäck"/"hartschale" etc. -> Filter auf gepaeckart-Facette.
// Im Index gibt es nur Hartgepäck / Weichgepäck / Hybrid; ohne diesen Filter fuzzy-matched
// "weichgepäck" sonst auf alle Nylon-Taschen via Material-Feld (Top-Treffer waren Umhängetaschen).
const GEPAECKART_PATTERNS = {
  'Weichgepäck': /\b(weichgep(?:ä|a|ae)ck|weichschalen?(?:koffer)?|softcase|softshell|stoffkoffer)\b/i,
  'Hartgepäck': /\b(hartgep(?:ä|a|ae)ck|hartschalen?(?:koffer)?|hardshell|hardcase|aluminiumkoffer|alukoffer)\b/i,
};

// Rollensystem-Detection: "4 rollen"/"spinner"/"vier rollen" -> rollensystem:=4 Rollen
// Verbessert das Ranking bei "koffer 4-rollen" (49x/Mon.) — sortiert nach boost_score statt
// nach Text-Match-Score (vorher: irrelevante Treffer wie Evoc/Victorinox oben statt Samsonite).
const ROLLENSYSTEM_PATTERNS = {
  '4 Rollen': /\b(4[\s\-]?rollen|vier[\s\-]?rollen|spinner|4[\s\-]?wheel)\b/i,
  '2 Rollen': /\b(2[\s\-]?rollen|zwei[\s\-]?rollen|2[\s\-]?wheel)\b/i,
};

/* Translated UI strings */
const UI_I18N = {
  de: { partnershopHeader:'„{brand}“ finden Sie bei unserem Partnershop', partnershopHint:'Unser Schwester-Shop premiumbags.com hat „{brand}“ für Sie im Sortiment:', partnershopCta:'Bei premiumbags.com ansehen', partnershopHintCount:'Unser Schwester-Shop premiumbags.com hat {count} „{brand}“-Produkte ab {price} im Sortiment:', partnershopTrust:'premiumbags.com ist unser Schwester-Shop — gleiche Firmengruppe, gewohnter Service.', storeOnlyHeader:'„{brand}“ finden Sie in unserem Ladengeschäft', storeOnlyHint:'Schicken Sie uns gerne eine Anfrage per Mail — wir erstellen Ihnen ein passendes Angebot.', storeOnlyCta:'Anfrage per Mail senden', noResults:'Keine Ergebnisse für', brandNotCarried:'Die Marke \u201e{brand}\u201c führen wir leider nicht.', tryInstead:'Vielleicht interessiert Sie:', popularBrands:'Beliebte Marken', popularCategories:'Beliebte Kategorien', products:'Produkte', sortBy:'Sortieren nach:', showMore:'Mehr anzeigen', showLess:'Weniger anzeigen', showFilters:'Filter anzeigen', maxPrice:'Höchstpreis', apply:'Anwenden', reduced:'Reduziert', yes:'Ja', details:'Details', soldOut:'Ausverkauft', resultsFor:'Ergebnisse gefunden für', clearAll:'Alle löschen', aiDetected:'KI-Frage erkannt – Möchten Sie eine persönliche Empfehlung zu Ihrer Suche?', aiLoad:'Jetzt Empfehlungen laden', aiLabel:'KI-Empfehlung', aiLoading:'Empfehlung wird geladen...', aiError:'Fehler beim Laden der Empfehlung.', aiNoAnswer:'Keine Empfehlung möglich.', aiFollowup:'Folgefrage stellen', aiSend:'Senden', aiAnswerLoading:'Antwort wird geladen...' },
  en: { partnershopHeader:'You can find “{brand}” at our partner shop', partnershopHint:'Our sister shop premiumbags.com has “{brand}” in stock for you:', partnershopCta:'View at premiumbags.com', partnershopHintCount:'Our sister shop premiumbags.com has {count} “{brand}” products from {price}:', partnershopTrust:'premiumbags.com is our sister shop — same company group, the service you know.', storeOnlyHeader:'You can find “{brand}” in our boutique', storeOnlyHint:'Send us a request by email — we’ll prepare a tailored offer for you.', storeOnlyCta:'Send email request', noResults:'No results for', brandNotCarried:'We don\u2019t carry the brand \u201c{brand}\u201d.', tryInstead:'You might like:', popularBrands:'Popular brands', popularCategories:'Popular categories', products:'Products', sortBy:'Sort by:', showMore:'Show more', showLess:'Show less', showFilters:'Show filters', maxPrice:'Max price', apply:'Apply', reduced:'On Sale', yes:'Yes', details:'Details', soldOut:'Sold out', resultsFor:'results found for', clearAll:'Clear all', aiDetected:'AI question detected – Would you like a personal recommendation?', aiLoad:'Load recommendations', aiLabel:'AI Recommendation', aiLoading:'Loading recommendation...', aiError:'Error loading recommendation.', aiNoAnswer:'No recommendation available.', aiFollowup:'Ask a follow-up question', aiSend:'Send', aiAnswerLoading:'Loading answer...' },
  fr: { partnershopHeader:'« {brand} » est disponible chez notre boutique partenaire', partnershopHint:'Notre boutique sœur premiumbags.com propose « {brand} » :', partnershopCta:'Voir sur premiumbags.com', partnershopHintCount:'Notre boutique sœur premiumbags.com propose {count} produits « {brand} » à partir de {price} :', partnershopTrust:'premiumbags.com est notre boutique sœur — même groupe, service habituel.', storeOnlyHeader:'« {brand} » est disponible dans notre boutique', storeOnlyHint:'Envoyez-nous une demande par e-mail — nous vous ferons une offre personnalisée.', storeOnlyCta:'Envoyer une demande par e-mail', noResults:'Aucun résultat pour', brandNotCarried:'Nous ne proposons pas la marque \u00ab\u202f{brand}\u202f\u00bb.', tryInstead:'Cela pourrait vous int\u00e9resser\u202f:', popularBrands:'Marques populaires', popularCategories:'Cat\u00e9gories populaires', products:'Produits', sortBy:'Trier par :', showMore:'Voir plus', showLess:'Voir moins', showFilters:'Afficher les filtres', maxPrice:'Prix max', apply:'Appliquer', reduced:'En promo', yes:'Oui', details:'Détails', soldOut:'Épuisé', resultsFor:'résultats trouvés pour', aiDetected:'Question IA détectée – Souhaitez-vous une recommandation personnalisée ?', aiLoad:'Charger les recommandations', aiLabel:'Recommandation IA', aiLoading:'Chargement...', aiError:'Erreur de chargement.', aiNoAnswer:'Aucune recommandation.', aiFollowup:'Poser une question', aiSend:'Envoyer', aiAnswerLoading:'Chargement...' },
  it: { partnershopHeader:'Trovi “{brand}” presso il nostro shop partner', partnershopHint:'Il nostro shop gemello premiumbags.com ha “{brand}” disponibile:', partnershopCta:'Vedi su premiumbags.com', partnershopHintCount:'Il nostro shop gemello premiumbags.com ha {count} prodotti “{brand}” a partire da {price}:', partnershopTrust:'premiumbags.com è il nostro shop gemello — stesso gruppo, il servizio di sempre.', storeOnlyHeader:'Trovi “{brand}” nel nostro negozio', storeOnlyHint:'Inviaci una richiesta via e-mail — ti prepareremo un’offerta su misura.', storeOnlyCta:'Invia richiesta via e-mail', noResults:'Nessun risultato per', brandNotCarried:'Non vendiamo il marchio \u201c{brand}\u201d.', tryInstead:'Potrebbe interessarti:', popularBrands:'Marchi popolari', popularCategories:'Categorie popolari', products:'Prodotti', sortBy:'Ordina per:', showMore:'Mostra di più', showLess:'Mostra meno', showFilters:'Mostra filtri', maxPrice:'Prezzo max', apply:'Applica', reduced:'In saldo', yes:'Sì', details:'Dettagli', soldOut:'Esaurito', resultsFor:'risultati trovati per', aiDetected:'Domanda IA rilevata – Vuoi una raccomandazione personalizzata?', aiLoad:'Carica raccomandazioni', aiLabel:'Raccomandazione IA', aiLoading:'Caricamento...', aiError:'Errore di caricamento.', aiNoAnswer:'Nessuna raccomandazione.', aiFollowup:'Fai una domanda', aiSend:'Invia', aiAnswerLoading:'Caricamento...' },
  es: { partnershopHeader:'Encuentra “{brand}” en nuestra tienda asociada', partnershopHint:'Nuestra tienda hermana premiumbags.com tiene “{brand}” disponible:', partnershopCta:'Ver en premiumbags.com', partnershopHintCount:'Nuestra tienda hermana premiumbags.com tiene {count} productos “{brand}” desde {price}:', partnershopTrust:'premiumbags.com es nuestra tienda hermana — mismo grupo empresarial, el servicio de siempre.', storeOnlyHeader:'Encuentra “{brand}” en nuestra tienda', storeOnlyHint:'Envíenos una consulta por correo — le prepararemos una oferta personalizada.', storeOnlyCta:'Enviar consulta por correo', noResults:'Sin resultados para', brandNotCarried:'No vendemos la marca \u201c{brand}\u201d.', tryInstead:'Quiz\u00e1s le interese:', popularBrands:'Marcas populares', popularCategories:'Categor\u00edas populares', products:'Productos', sortBy:'Ordenar por:', showMore:'Ver más', showLess:'Ver menos', showFilters:'Mostrar filtros', maxPrice:'Precio máx', apply:'Aplicar', reduced:'En oferta', yes:'Sí', details:'Detalles', soldOut:'Agotado', resultsFor:'resultados encontrados para', aiDetected:'Pregunta IA detectada – ¿Desea una recomendación personalizada?', aiLoad:'Cargar recomendaciones', aiLabel:'Recomendación IA', aiLoading:'Cargando...', aiError:'Error al cargar.', aiNoAnswer:'Sin recomendación.', aiFollowup:'Hacer una pregunta', aiSend:'Enviar', aiAnswerLoading:'Cargando...' },
  nl: { partnershopHeader:'U vindt „{brand}” bij onze partnerwinkel', partnershopHint:'Onze zusterwinkel premiumbags.com heeft „{brand}” op voorraad:', partnershopCta:'Bekijk op premiumbags.com', partnershopHintCount:'Onze zusterwinkel premiumbags.com heeft {count} “{brand}”-producten vanaf {price}:', partnershopTrust:'premiumbags.com is onze zusterwinkel — dezelfde bedrijfsgroep, vertrouwde service.', storeOnlyHeader:'U vindt „{brand}” in onze winkel', storeOnlyHint:'Stuur ons een aanvraag per e-mail — wij maken u een passende offerte.', storeOnlyCta:'Aanvraag per e-mail sturen', noResults:'Geen resultaten voor', brandNotCarried:'Het merk \u201e{brand}\u201d voeren wij helaas niet.', tryInstead:'Misschien interessant voor u:', popularBrands:'Populaire merken', popularCategories:'Populaire categorie\u00ebn', products:'Producten', sortBy:'Sorteren op:', showMore:'Meer tonen', showLess:'Minder tonen', showFilters:'Filters tonen', maxPrice:'Max prijs', apply:'Toepassen', reduced:'Afgeprijsd', yes:'Ja', details:'Details', soldOut:'Uitverkocht', resultsFor:'resultaten gevonden voor', aiDetected:'AI-vraag herkend – Wilt u een persoonlijk advies?', aiLoad:'Aanbevelingen laden', aiLabel:'AI-aanbeveling', aiLoading:'Laden...', aiError:'Fout bij laden.', aiNoAnswer:'Geen aanbeveling.', aiFollowup:'Stel een vervolgvraag', aiSend:'Verzenden', aiAnswerLoading:'Laden...' },
};
const UI = UI_I18N[TS_LANG] || UI_I18N.de;

// Marken die NICHT geführt werden — bekannte Zero-Result-Queries.
// Bei Match: Brand-Not-Carried-UI zeigen, keine irreführenden drop_tokens-Fake-Treffer.
const NOT_CARRIED_BRANDS = new Set([
  'rimowa', 'rimow', 'rimoa', 'rimova',
  'patagonia', 'patagonija',
  'bogner', 'jordan', 'yeti',
  'mountain hardwear', 'arcteryx', "arc'teryx",
  'ortovox', 'liebeskind',
]);
function detectNotCarriedBrand(query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) return null;
  if (NOT_CARRIED_BRANDS.has(q)) return q;
  const words = q.split(/\s+/);
  if (NOT_CARRIED_BRANDS.has(words[0])) return words[0];
  if (words.length >= 2 && NOT_CARRIED_BRANDS.has(words.slice(0, 2).join(' '))) return words.slice(0, 2).join(' ');
  return null;
}

// Marken/Serien die wir auf markenkoffer.de NICHT führen, aber im Schwester-Shop premiumbags.com.
// Bei Match: Treffer ausblenden, Hinweis-Banner mit Link zum Partnershop.
const PARTNERSHOP_BRANDS = [
  { match: ['tumi'], displayBrand: 'Tumi', url: 'https://www.premiumbags.com/search?q=tumi' },
  { match: ['ecodiver', 'eco diver', 'samsonite ecodiver', 'samsonite eco diver'], displayBrand: 'Samsonite Ecodiver', url: 'https://www.premiumbags.com/search?q=ecodiver' },
  { match: ['upscape', 'up scape', 'samsonite upscape', 'samsonite up scape'], displayBrand: 'Samsonite Upscape', url: 'https://www.premiumbags.com/search?q=upscape' },
];
function detectPartnershopBrand(query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) return null;
  for (const entry of PARTNERSHOP_BRANDS) {
    for (const kw of entry.match) {
      if (q === kw || q.includes(kw)) {
        return { displayBrand: entry.displayBrand, url: entry.url };
      }
    }
  }
  return null;
}

// Marken die wir nur stationär im Ladengeschäft führen.
// Bei Match: Treffer ausblenden, Banner mit Mail-CTA für Angebotsanfrage.
const STORE_ONLY_BRANDS = [
  { match: ['longchamp'], displayBrand: 'Longchamp' },
];
const STORE_ONLY_MAIL = 'service@markenkoffer.de';
function detectStoreOnlyBrand(query) {
  const q = (query || '').toLowerCase().trim();
  if (!q) return null;
  for (const entry of STORE_ONLY_BRANDS) {
    for (const kw of entry.match) {
      if (q === kw || q.includes(kw)) {
        return { displayBrand: entry.displayBrand };
      }
    }
  }
  return null;
}

// Service-Links: Keywords die auf Hilfeseiten statt Produktsuche fuehren
const SERVICE_LINKS_PAGE = [
  { keywords: ['retoure', 'retouren', 'retourenportal', 'retourenlabel', 'retourenlabe', 'rücksendung', 'ruecksendung', 'rücksenden', 'ruecksenden', 'rückversand', 'rueckversand', 'retour', 'zurückschicken', 'zurücksenden', 'zurueckschicken', 'zurueckschicken', 'umtausch', 'return', 'returns', 'rückgabe', 'rueckgabe', 'reklamation', 'paket zurück', 'paket zurueck'],
    url: '/pages/retoure_dhl',
    label: { de: 'Zum Retourenportal', en: 'Go to returns portal', fr: 'Portail de retours', it: 'Portale resi', es: 'Portal de devoluciones', nl: 'Retourportaal' } },
  { keywords: ['kontakt', 'contact', 'telefon', 'anrufen', 'email', 'e-mail', 'hotline', 'kundenservice', 'kundendienst'],
    url: '/pages/kontakt',
    label: { de: 'Zum Kundenservice', en: 'Contact us', fr: 'Nous contacter', it: 'Contattaci', es: 'Contacto', nl: 'Klantenservice' } },
  { keywords: ['versand', 'lieferung', 'lieferzeit', 'shipping', 'delivery', 'versandkosten', 'dhl', 'zustellung', 'liefertermin'],
    url: '/pages/versand',
    label: { de: 'Versand & Lieferung', en: 'Shipping & Delivery', fr: 'Livraison', it: 'Spedizione', es: 'Envío', nl: 'Verzending' } },
  { keywords: ['gutschein', 'gutscheine', 'voucher', 'gift card', 'geschenkgutschein'],
    url: '/pages/gutscheine',
    label: { de: 'Gutscheine kaufen', en: 'Buy gift cards', fr: 'Bons d\'achat', it: 'Buoni regalo', es: 'Tarjetas regalo', nl: 'Cadeaubonnen' } },
  { keywords: ['service', 'hilfe', 'help', 'support', 'faq', 'fragen'],
    url: '/pages/service-hilfe',
    label: { de: 'Service & Hilfe', en: 'Service & Help', fr: 'Aide', it: 'Aiuto', es: 'Ayuda', nl: 'Hulp' } },
  { keywords: ['widerruf', 'widerrufsrecht', 'widerrufsbelehrung', 'widerrufsformular'],
    url: '/policies/refund-policy',
    label: { de: 'Widerrufsrecht', en: 'Right of withdrawal', fr: 'Droit de rétractation', it: 'Diritto di recesso', es: 'Derecho de desistimiento', nl: 'Herroepingsrecht' } },
  { keywords: ['datenschutz', 'datenschutzerklärung', 'privacy', 'dsgvo', 'gdpr'],
    url: '/policies/privacy-policy',
    label: { de: 'Datenschutz', en: 'Privacy Policy', fr: 'Confidentialité', it: 'Privacy', es: 'Privacidad', nl: 'Privacy' } },
  { keywords: ['agb', 'agbs', 'geschäftsbedingungen', 'terms', 'conditions'],
    url: '/policies/terms-of-service',
    label: { de: 'AGB', en: 'Terms of Service', fr: 'CGV', it: 'Termini', es: 'Condiciones', nl: 'Voorwaarden' } },
  { keywords: ['impressum', 'imprint', 'legal'],
    url: '/policies/legal-notice',
    label: { de: 'Impressum', en: 'Legal Notice', fr: 'Mentions légales', it: 'Note legali', es: 'Aviso legal', nl: 'Colofon' } },
  { keywords: ['marken', 'brands', 'markenliste', 'all brands'],
    url: '/pages/marken',
    label: { de: 'Alle Marken', en: 'All brands', fr: 'Toutes les marques', it: 'Tutte le marche', es: 'Todas las marcas', nl: 'Alle merken' } },
  { keywords: ['inspirationen', 'inspiration', 'blog', 'magazin'],
    url: '/pages/inspirationen',
    label: { de: 'Inspirationen', en: 'Inspirations', fr: 'Inspirations', it: 'Ispirazioni', es: 'Inspiraciones', nl: 'Inspiraties' } },
  { keywords: ['jobs', 'karriere', 'career', 'stellenangebote', 'stelle'],
    url: '/pages/stellenangebote',
    label: { de: 'Karriere bei uns', en: 'Careers', fr: 'Carrières', it: 'Carriere', es: 'Empleo', nl: 'Carrière' } },
  { keywords: ['unternehmen', 'firma', 'about', 'about us', 'über uns', 'company'],
    url: '/pages/unternehmen',
    label: { de: 'Über uns', en: 'About us', fr: 'À propos', it: 'Chi siamo', es: 'Sobre nosotros', nl: 'Over ons' } },
  { keywords: ['steuerfrei', 'tax free', 'taxfree', 'tax-free', 'duty free'],
    url: '/pages/steuerfrei-einkaufen',
    label: { de: 'Steuerfrei einkaufen', en: 'Tax-free shopping', fr: 'Achats hors taxes', it: 'Tax free', es: 'Compras libres de impuestos', nl: 'Belastingvrij' } },
  { keywords: ['boutique'],
    url: '/pages/boutique',
    label: { de: 'Unsere Boutique', en: 'Our boutique', fr: 'Notre boutique', it: 'La nostra boutique', es: 'Nuestra boutique', nl: 'Onze boutique' } },
  { keywords: ['newsletter', 'newsletter anmelden', 'newsletter abonnieren', 'newsletter abmelden', 'newslettr', 'abonnieren', 'subscribe', 'subscription'],
    url: '/pages/newsletter',
    label: { de: 'Newsletter abonnieren', en: 'Subscribe to newsletter', fr: 'S\'abonner à la newsletter', it: 'Iscriviti alla newsletter', es: 'Suscribirse al boletín', nl: 'Aanmelden voor nieuwsbrief' } },
];

function detectServiceLinkPage(query) {
  const qLower = query.toLowerCase().trim();
  const qWords = qLower.split(/\s+/);
  for (const link of SERVICE_LINKS_PAGE) {
    if (link.keywords.some(kw => qWords.includes(kw) || qLower.includes(kw))) {
      return { url: link.url, label: link.label[TS_LANG] || link.label.de };
    }
  }
  return null;
}

const ARROW_SVG = '<svg width="12" height="7" viewBox="0 0 12 7" fill="none"><path d="M11 1L6 6L1 1" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const REMOVE_SVG = '<svg width="7" height="7" viewBox="0 0 7 7" fill="none"><path d="M6.4731 6.875C6.60027 6.875 6.72968 6.82592 6.82561 6.72775C7.01972 6.53364 7.01972 6.21682 6.82561 6.02049L4.67929 3.87416L6.82561 1.72784C7.01972 1.53373 7.01972 1.21692 6.82561 1.02058C6.63151 0.826473 6.31469 0.826473 6.11835 1.02058L3.97203 3.1669L1.82794 1.02504C1.63383 0.830936 1.31701 0.830936 1.12068 1.02504C0.926571 1.21915 0.926571 1.53596 1.12068 1.7323L3.267 3.87863L1.12291 6.02049C0.928802 6.21459 0.928802 6.53141 1.12291 6.72775C1.22108 6.82592 1.34825 6.875 1.47542 6.875C1.6026 6.875 1.732 6.82592 1.82794 6.72775L3.97426 4.58142L6.12058 6.72775C6.21652 6.82592 6.34593 6.875 6.4731 6.875Z" fill="var(--color-accent)"/></svg>';

// --- Search Analytics (non-blocking) ---
const _pageAnalyticsUrl = 'https://webhooks.markenkoffer.de/analytics/event';
// Dedup: gleiche (type+query) innerhalb 60s pro Tab nicht doppelt tracken
const _TRACK_DEDUP_MS = 60000;
function _shouldTrack(type, query) {
  try {
    const key = type + ':' + (query || '').toLowerCase().trim();
    const now = Date.now();
    const store = JSON.parse(sessionStorage.getItem('ts_last_tracked') || '{}');
    // Alte Eintraege aufraeumen (max 20 behalten)
    const keys = Object.keys(store);
    if (keys.length > 20) {
      keys.sort((a, b) => store[a] - store[b]).slice(0, keys.length - 20).forEach(k => delete store[k]);
    }
    if (store[key] && now - store[key] < _TRACK_DEDUP_MS) return false;
    store[key] = now;
    sessionStorage.setItem('ts_last_tracked', JSON.stringify(store));
    return true;
  } catch (e) { return true; /* sessionStorage blocked → nicht blockieren */ }
}
function trackPageSearch(type, query, extra = {}) {
  try {
    // Klicks immer tracken (nicht deduplizieren)
    if (type !== 'click' && !_shouldTrack(type, query)) return;
    const body = JSON.stringify({ type, query, ...extra });
    if (navigator.sendBeacon) {
      navigator.sendBeacon(_pageAnalyticsUrl, new Blob([body], { type: 'application/json' }));
    }
  } catch (e) { /* silent */ }
}

/* Map Typesense field names to the slug the theme CSS expects */
const SLUG_MAP = { suchfarbe: 'color' };

/* German color name → CSS color for swatch display */
const COLOR_MAP = {
  schwarz: '#000', black: '#000', weiss: '#fff', weiß: '#fff', white: '#fff',
  blau: '#0055b8', blue: '#0055b8', dunkelblau: '#002f6c', hellblau: '#7fbfff', navy: '#001f3f',
  rot: '#cc0000', red: '#cc0000', rosa: '#ffb6c1', pink: '#ff69b4',
  gruen: '#228b22', grün: '#228b22', green: '#228b22', oliv: '#808000',
  gelb: '#ffd700', yellow: '#ffd700', orange: '#ff8c00',
  braun: '#8b4513', brown: '#8b4513', beige: '#f5f5dc', taupe: '#483c32', cognac: '#9a463d',
  grau: '#808080', grey: '#808080', gray: '#808080', silber: '#c0c0c0', anthrazit: '#383838',
  lila: '#800080', violett: '#7b2d8b', purple: '#800080',
  gold: '#d4a017', kupfer: '#b87333', bronze: '#cd7f32',
  bordeaux: '#6b0c32', petrol: '#006b6b', tuerkis: '#40e0d0', türkis: '#40e0d0',
  bunt: 'linear-gradient(135deg,#f00,#ff0,#0f0,#0ff,#00f,#f0f)',
  multicolor: 'linear-gradient(135deg,#f00,#ff0,#0f0,#0ff,#00f,#f0f)',
};

class TypesenseSearchPage {
  constructor() {
    const cfg = document.getElementById('ts-search-config');
    if (!cfg) return;

    this.query = cfg.dataset.query || '';
    this.perPage = parseInt(cfg.dataset.perPage) || 24;
    this.columns = parseInt(cfg.dataset.columns) || 4;
    this.badgePosition = cfg.dataset.badgePosition || 'bottom left';
    this.currentPage = 1;
    this.activeFilters = {};
    this.sortBy = '_text_match:desc,boost_score:desc';
    this.totalFound = 0;

    // KI conversation state
    this.conversationId = null;
    this.aiMessages = []; // Accumulated chat messages
    this.cachedAiRewrite = null; // Cached AI rewrite result for pagination

    // Query preprocessing: detect trip duration, status keywords, and clean query
    this.tripSize = null; // null | 'small' | 'medium' | 'large'
    this.statusFilter = null; // null | 'SALE' | 'Neu'
    this.cleanQuery = this.preprocessQuery(this.query);

    this.gridEl = document.getElementById('ts-product-grid');
    this.facetsEl = document.getElementById('ts-facets-sidebar');
    this.mobileFacetsEl = document.getElementById('ts-mobile-facets');
    this.mobileDrawer = document.getElementById('ts-mobile-drawer');
    this.paginationEl = document.getElementById('ts-pagination');
    this.sortEl = document.getElementById('ts-sort-select');
    this.countEl = document.getElementById('ts-result-count');
    this.loadingEl = document.getElementById('ts-loading');

    this.initSort();
    this.parseUrlParams();
    this.search();
    this.initAiWidget();

    // Browser-Back/Forward: URL-State neu lesen und Suche refreshen
    window.addEventListener('popstate', () => {
      this.activeFilters = {};
      this.collectionTitle = null;
      this.sortBy = '_text_match:desc,boost_score:desc';
      this.currentPage = 1;
      const params = new URLSearchParams(window.location.search);
      this.query = params.get('q') || this.query;
      this.cleanQuery = this.preprocessQuery(this.query);
      this.parseUrlParams();
      if (this.sortEl) this.sortEl.value = this.sortBy;
      this.search();
    });
  }

  initSort() {
    if (!this.sortEl) return;
    this.sortEl.innerHTML = SORT_OPTIONS.map(o =>
      `<option value="${o.value}"${o.value === this.sortBy ? ' selected' : ''}>${o.label}</option>`
    ).join('');
    this.sortEl.addEventListener('change', (e) => {
      this.sortBy = e.target.value;
      this.currentPage = 1;
      this.search();
    });
  }

  parseUrlParams() {
    const params = new URLSearchParams(window.location.search);
    for (const [key, val] of params.entries()) {
      if (key.startsWith('ts_f_')) {
        this.activeFilters[key.slice(5)] = val.split(',');
      }
    }
    // Collection-Filter aus Autocomplete-Kategorie-Klick (Titel, nicht Handle)
    if (params.get('collection')) {
      this.collectionTitle = params.get('collection');
    }
    if (params.get('ts_sort')) {
      this.sortBy = params.get('ts_sort');
      if (this.sortEl) this.sortEl.value = this.sortBy;
    }
    if (params.get('page')) this.currentPage = parseInt(params.get('page')) || 1;
  }

  preprocessQuery(q) {
    // Detect status keywords: sale, neu, neuheiten -> custom_status filter
    // Sprach-spezifisch + nur bei kurzen Queries (<4 Wörter)
    let cleaned = q;
    const _wordCount = cleaned.trim().split(/\s+/).length;
    if (_wordCount < 4) {
      const saleByLang = {
        de: /\b(sale|reduziert|angebot|angebote|rabatt|reduzierte?|%)\b/i,
        en: /\b(sale|discount|discounts|offer|offers|%)\b/i,
        fr: /\b(solde|soldes|promo|promos|réduction|reduction|%)\b/i,
        it: /\b(saldo|saldi|sconto|sconti|%)\b/i,
        es: /\b(oferta|ofertas|descuento|descuentos|rebaja|rebajas|%)\b/i,
        nl: /\b(sale|aanbieding|aanbiedingen|korting|kortingen|%)\b/i,
      };
      // "neu" DE (ohne "new" — kollidiert mit Produktnamen wie "BOSS New Crosstown"), "new" EN, usw.
      const neuByLang = {
        de: /\b(neu|neuheit|neuheiten|neue|neues|neuer)\b/i,
        en: /\b(new|new arrivals)\b/i,
        fr: /\b(nouveau|nouvelle|nouveautes|nouveautés)\b/i,
        it: /\b(nuovo|nuova|novita|novità)\b/i,
        es: /\b(nuevo|nueva|novedad|novedades)\b/i,
        nl: /\b(nieuw|nieuwe|nieuwtjes)\b/i,
      };
      const salePattern = saleByLang[TS_LANG] || saleByLang.de;
      const neuPattern = neuByLang[TS_LANG] || neuByLang.de;
      if (salePattern.test(cleaned)) {
        this.statusFilter = 'SALE';
        cleaned = cleaned.replace(salePattern, '').trim();
      } else if (neuPattern.test(cleaned)) {
        this.statusFilter = 'Neu';
        cleaned = cleaned.replace(neuPattern, '').trim();
      }
    }

    // Maße-Suche "55x40x23" / "55 x 40 x 23" / "55*40*23" / "55X40X23cm"
    // Setzt Filter auf hoehe_cm/breite_cm/tiefe_cm mit ±2cm Toleranz (IATA-Vergleich)
    const dimMatch = cleaned.match(/\b(\d{2,3})\s*[x*×X]\s*(\d{2,3})\s*[x*×X]\s*(\d{2,3})\s*(?:cm)?\b/);
    if (dimMatch) {
      this.dimFilter = {
        h: parseInt(dimMatch[1], 10),
        b: parseInt(dimMatch[2], 10),
        t: parseInt(dimMatch[3], 10),
      };
      // Maße aus Query entfernen damit Zahlen nicht in Volltextsuche stören
      cleaned = cleaned.replace(/\b\d{2,3}\s*[x*×X]\s*\d{2,3}\s*[x*×X]\s*\d{2,3}\s*(?:cm)?\b/, '').trim();
    } else {
      this.dimFilter = null;
    }

    // Gepäckart-Detection (weichgepäck/hartschale/softcase/...) -> Filter auf gepaeckart-Facette
    this.gepaeckartFilter = null;
    for (const [value, pattern] of Object.entries(GEPAECKART_PATTERNS)) {
      if (pattern.test(cleaned)) {
        this.gepaeckartFilter = value;
        cleaned = cleaned.replace(pattern, '').trim();
        break;
      }
    }

    // Rollensystem-Detection ("4 rollen"/"spinner") -> Filter auf rollensystem-Facette
    this.rollensystemFilter = null;
    for (const [value, pattern] of Object.entries(ROLLENSYSTEM_PATTERNS)) {
      if (pattern.test(cleaned)) {
        this.rollensystemFilter = value;
        cleaned = cleaned.replace(pattern, '').trim();
        break;
      }
    }

    // Detect trip-duration patterns and determine recommended luggage size
    // "2 wochen" → large (77cm+), "1 woche" → medium (67cm+), "wochenende/2 tage" → small (55cm)

    // Match patterns like "2 wochen", "1 woche", "3 tage", "14 tage", "wochenende"
    const weekMatch = cleaned.match(/\b(\d+)\s*wochen?\b/i);
    const dayMatch = cleaned.match(/\b(\d+)\s*tage?\b/i);
    const weekendMatch = /\bwochenend\w*\b/i.test(cleaned);
    const urlaubMatch = /\b(urlaub|ferien|reise)\b/i.test(cleaned);

    if (weekMatch) {
      const weeks = parseInt(weekMatch[1]);
      this.tripSize = weeks >= 2 ? 'large' : 'medium';
      // Remove the "X wochen" from query so "2" doesn't match "2-Rollen"
      cleaned = cleaned.replace(/\b\d+\s*wochen?\b/i, '').trim();
    } else if (dayMatch) {
      const days = parseInt(dayMatch[1]);
      if (days >= 10) this.tripSize = 'large';
      else if (days >= 5) this.tripSize = 'medium';
      else this.tripSize = 'small';
      cleaned = cleaned.replace(/\b\d+\s*tage?\b/i, '').trim();
    } else if (weekendMatch) {
      this.tripSize = 'small';
      cleaned = cleaned.replace(/\bwochenend\w*\b/i, '').trim();
    } else if (urlaubMatch) {
      // Generic "urlaub/reise" without duration → medium
      this.tripSize = 'medium';
    }

    // Deutsche Stoppwörter entfernen (verbessert Suchen wie "schulranzen für mädchen", "koffer mit 4 rollen")
    const stopwords = /\b(für|fuer|mit|und|oder|von|aus|bei|zum|zur|ein|eine|einen|einem|einer|der|die|das|den|dem|des|ist|sind|hat|haben|wird|kann|nach|über|ueber|unter|zwischen|ohne|gegen|sehr|auch|nur|aber|noch|schon|mehr|viel|ganz)\b/gi;
    cleaned = cleaned.replace(stopwords, ' ');

    // Typesense-Operatoren neutralisieren: führendes - bedeutet "exclude", + bedeutet "must include"
    // Passiert z.B. wenn User Produkttitel mit "+" kopiert — URL-Form-Submit wandelt + zu space,
    // dann steht "-4-Rollen-Trolley" am Wortanfang und wird zur Negation.
    // Klammern ebenfalls entfernen (Typesense-Gruppierung).
    cleaned = cleaned.replace(/(^|\s)[+\-]+(?=\S)/g, '$1');
    cleaned = cleaned.replace(/[()]/g, ' ');

    // Clean up multiple spaces
    return cleaned.replace(/\s{2,}/g, ' ').trim();
  }

  // Erkennt ob Query ein Vendor-Name ist (z.B. "samsonite" -> "Samsonite")
  detectVendor(query) {
    if (!window.BRAND_NAMES) return null;
    const qLower = (query || '').toLowerCase().trim();
    if (!qLower) return null;
    // Exakter Match oder Query beginnt mit Vendor-Name
    for (const [key, val] of Object.entries(window.BRAND_NAMES)) {
      if (qLower === key || qLower.startsWith(key + ' ')) return val;
    }
    return null;
  }

  buildSortBy() {
    // When user searches for luggage-related terms, boost main products over accessories
    const luggageTerms = /\b(koffer|trolley|reisekoffer|hartschale|weichgep|handgep|cabin|kabine|rollkoffer|spinner)\b/i;
    const isLuggageSearch = luggageTerms.test(this.query);

    if (this.sortBy !== '_text_match:desc,boost_score:desc') {
      // User selected a custom sort - respect it
      return this.sortBy;
    }

    // Status-only queries (e.g. "sale", "neuheiten") without other terms -> sort by bestseller
    if (this.statusFilter && !this.cleanQuery) {
      return 'boost_score:desc';
    }

    // Build _eval rules
    const evalRules = [];

    // Vendor-Boost: wenn Query ein Markenname ist, diese Marke stark boosten.
    // _eval ist first-match (nicht additiv): die Reihenfolge der Regeln entscheidet. Bei reiner
    // Marken-Query muss "Marke UND Hauptprodukt" als erste Regel stehen, sonst gewinnt die spaetere
    // MAIN-Regel fuer fremde Hauptprodukte (KLICKfix-Fahrradkoerbe standen bei "reisenthel" oben).
    const detectedVendor = this.detectVendor(this.query);
    const isPureVendorQuery = detectedVendor && this.query.trim().toLowerCase() === detectedVendor.toLowerCase();
    if (isPureVendorQuery) {
      evalRules.push(`(vendor:\`${detectedVendor}\` && product_type:[${TS_PAGE_MAIN_LIST}]):120`);
    }
    if (detectedVendor) {
      evalRules.push(`(vendor:\`${detectedVendor}\`):40`);
    }
    // Pure Vendor-Query: fremde Hauptprodukte hinter allen Markenartikeln, aber vor fremdem Zubehoer.
    // boost_score:desc (zweiter Sortierschluessel) bestimmt innerhalb der Stufen den Bestseller.
    if (isPureVendorQuery) {
      evalRules.push(`(product_type:[${TS_PAGE_MAIN_LIST}]):5`);
    }

    if (isLuggageSearch) {
      // Boost real luggage above accessories (Koffergurt, Kofferwaage)
      evalRules.push('(product_type:`Trolley/Koffer`):3');
      evalRules.push('(product_type:`Reisetasche`):2');
      evalRules.push('(product_type:`Rucksack`):2');
    }

    // Trip-size boosting: use separate _eval for size to ensure it dominates
    if (this.tripSize === 'large') {
      // 2+ weeks: boost 75cm+ suitcases strongly
      return `_eval([(groesse_sort:>=75):10,(groesse_sort:[67..74]):5${isLuggageSearch ? ',(product_type:`Trolley/Koffer`):2' : ''}]):desc,_text_match(buckets:10):desc,boost_score:desc`;
    } else if (this.tripSize === 'medium') {
      // 1 week: boost 67cm+ suitcases
      return `_eval([(groesse_sort:>=67):10,(groesse_sort:[55..66]):4${isLuggageSearch ? ',(product_type:`Trolley/Koffer`):2' : ''}]):desc,_text_match(buckets:10):desc,boost_score:desc`;
    } else if (this.tripSize === 'small') {
      // Weekend/short trip: boost cabin sizes
      return `_eval([(groesse_sort:<=55):10${isLuggageSearch ? ',(product_type:`Trolley/Koffer`):2' : ''}]):desc,_text_match(buckets:10):desc,boost_score:desc`;
    }

    if (evalRules.length > 0) {
      // Bei reiner Vendor-Query: boost_score VOR _text_match, damit Bestseller klar oben stehen
      if (isPureVendorQuery) {
        return `_eval([${evalRules.join(',')}]):desc,boost_score:desc,_text_match:desc`;
      }
      return `_eval([${evalRules.join(',')}]):desc,_text_match(buckets:10):desc,boost_score:desc`;
    }

    // buckets:10 = Relevanz in 10 Stufen, innerhalb einer Stufe Bestseller (boost_score) zuerst.
    // Ohne buckets ist der Hybrid-Textscore je Produkt unterschiedlich und boost_score griffe nie.
    return '_text_match(buckets:10):desc,boost_score:desc';
  }

  buildFilterBy() {
    let filters = ['available:true', 'status:active'];
    // Automatischer Status-Filter bei Sale/Neu Queries
    if (this.statusFilter) {
      filters.push(`custom_status:=${this.statusFilter}`);
    }
    // Maße-Filter aus erkanntem HxBxT (±2cm Toleranz)
    if (this.dimFilter) {
      const { h, b, t } = this.dimFilter;
      filters.push(`hoehe_cm:[${h-2}..${h+2}]`);
      filters.push(`breite_cm:[${b-2}..${b+2}]`);
      filters.push(`tiefe_cm:[${t-2}..${t+2}]`);
    }
    // Gepäckart-Filter aus Query erkannt (weichgepäck/hartschale)
    if (this.gepaeckartFilter) {
      filters.push('gepaeckart:=`' + this.gepaeckartFilter + '`');
    }
    // Rollensystem-Filter aus Query erkannt (4-rollen/2-rollen/spinner)
    if (this.rollensystemFilter) {
      filters.push('rollensystem:=`' + this.rollensystemFilter + '`');
    }
    // Collection-Filter aus Autocomplete-Kategorie-Klick
    if (this.collectionTitle) {
      filters.push('collections:=`' + this.collectionTitle + '`');
    }
    for (const [field, values] of Object.entries(this.activeFilters)) {
      if (field === 'price' && values.length === 1) {
        filters.push(`price:${values[0]}`);
      } else if (field === 'on_sale' || field === 'vortasche') {
        if (values.includes('true') || values.includes(true)) {
          filters.push(`${field}:true`);
        }
      } else if (values.length > 0) {
        const escaped = values.map(v => '`' + v + '`').join(',');
        filters.push(`${field}:=[${escaped}]`);
      }
    }
    return filters.join(' && ');
  }

  async search() {
    if (this.loadingEl) this.loadingEl.style.display = 'flex';

    // Pure Service-Query (z.B. "retoure", "newsletter", "kontakt"): User tippt
    // GENAU ein Service-Keyword -> direkt Banner zeigen, KEIN Typesense-Call.
    // Spart Analytics-Verzerrung (sonst landen ~400/Mon. retoure/newsletter
    // als Zero-Hits in nohits_queries_<lang>) und einen Server-Call.
    const qTrim = (this.query || '').toLowerCase().trim();
    if (qTrim) {
      for (const link of SERVICE_LINKS_PAGE) {
        if (link.keywords.includes(qTrim)) {
          if (this.loadingEl) this.loadingEl.style.display = 'none';
          this.renderProminentServiceBanner({
            url: link.url,
            label: link.label[TS_LANG] || link.label.de,
          });
          // Skeleton ausblenden + Hauptinhalt einblenden (sonst bleibt der
          // Banner in #ts-main-content unsichtbar und das Skeleton pulsiert ewig)
          this.revealContent();
          return;
        }
      }
    }

    // Nicht geführte Marken erkennen — wir lassen die Suche aber normal laufen,
    // leeren die Hits vor dem Rendering (Facets nutzen wir für Alternativen-Marken).
    this._notCarriedBrand = detectNotCarriedBrand(this.query);

    const baseUrl = `${TS_PAGE.protocol}://${TS_PAGE.host}:${TS_PAGE.port}`;

    // AI Query Rewriting: bei NL-Queries den LLM fragen, Ergebnis cachen fuer Pagination
    let aiRewrite = this.cachedAiRewrite;
    const hasManualFilters = Object.keys(this.activeFilters).length > 0;
    // AI Rewrite nur wenn bereinigte Query (nach Stoppwort-Entfernung) noch wie NL aussieht
    const cleanQ = this.cleanQuery || this.query;
    if (!aiRewrite && !hasManualFilters && isNLQuery(cleanQ)) {
      aiRewrite = await aiRewriteQuery(cleanQ, TS_LANG);
      if (aiRewrite) this.cachedAiRewrite = aiRewrite;
    }
    // Bei manuellen Filtern: AI-Cache verwerfen, User hat eigene Filter gesetzt
    if (hasManualFilters) aiRewrite = null;

    // Wenn AI-Rewrite verfuegbar, dessen Parameter nutzen
    // Bei reinem dimFilter ohne Text-Begriff: '*' damit Filter alleine arbeitet
    const effectiveQ = aiRewrite?.q || this.cleanQuery || ((this.statusFilter || this.dimFilter || this.gepaeckartFilter || this.rollensystemFilter) ? '*' : this.query);
    let effectiveFilterBy = this.buildFilterBy();
    let effectiveSortBy = this.buildSortBy();

    if (aiRewrite) {
      // AI-Filter mit bestehenden Pflicht-Filtern mergen
      if (aiRewrite.filter_by) {
        const aiFilter = aiRewrite.filter_by;
        const parts = [];
        if (!aiFilter.includes('available:')) parts.push('available:true');
        if (!aiFilter.includes('status:')) parts.push('status:active');
        parts.push(aiFilter);
        effectiveFilterBy = parts.join(' && ');
      }
      // AI sort_by nur verwenden wenn der User NICHT manuell sortiert hat
      const userChangedSort = this.sortBy !== '_text_match:desc,boost_score:desc';
      if (aiRewrite.sort_by && !userChangedSort) {
        effectiveSortBy = aiRewrite.sort_by;
      }
    }

    // body_html komplett aus query_by entfernt:
    // - Verursacht falsche Treffer (z.B. "mädchen" nur in Beschreibung -> filtert echte Ergebnisse)
    // - "schulranzen für mädchen" lieferte 10 statt 117 Treffer mit body_html
    // - search_keywords enthaelt bereits die relevanten Daten aus body_html
    // Pure Vendor-Query: Embedding weglassen, damit Bestseller-Sortierung nicht von Semantik überlagert wird
    const _detectedVendorForQuery = this.detectVendor(this.query);
    const _isPureVendor = _detectedVendorForQuery && this.query.trim().toLowerCase() === _detectedVendorForQuery.toLowerCase();
    const _useEmbed = HAS_EMBEDDING_PAGE && !_isPureVendor;
    const queryBy = _useEmbed
      ? 'title,vendor,product_type,search_keywords,tags,sku,color,material,embedding'
      : 'title,vendor,product_type,search_keywords,tags,sku,color,material';
    const queryByWeights = _useEmbed ? '10,10,8,4,3,2,2,1,1' : '10,10,8,4,3,2,2,1';
    const prefixStr = _useEmbed
      ? 'true,true,true,true,true,true,true,true,false'
      : 'true,true,true,true,true,true,true,true';

    const searchParams = {
      collection: TS_PAGE.collection,
      q: effectiveQ,
      query_by: queryBy,
      query_by_weights: queryByWeights,
      ...(_useEmbed ? { vector_query: 'embedding:([], k:20, alpha:0.5)' } : {}),
      prefix: prefixStr,
      filter_by: effectiveFilterBy,
      facet_by: 'vendor,product_type,price,suchfarbe,groesse_gruppe,volumen_gruppiert,material,gewicht_gruppiert,rollensystem,gepaeckart,serie,ausstattung,rabatt_gruppe,on_sale,vortasche,themenbereich,custom_status,gender',
      max_facet_values: 100,
      sort_by: effectiveSortBy,
      per_page: this.perPage,
      page: this.currentPage,
      num_typos: 2,
      text_match_type: 'max_weight',
      drop_tokens_threshold: 3,
      prioritize_exact_match: true,
      exclude_fields: 'body_html,search_keywords,embedding',
      highlight_full_fields: 'title',
      highlight_start_tag: '<mark>',
      highlight_end_tag: '</mark>',
    };

    // audit medium-12: AbortController + Stale-Guard wie im Autocomplete —
    // sonst ueberschreibt bei schnellen Filter-Klicks eine langsamere aeltere
    // Antwort die neueren Ergebnisse (Grid passt nicht mehr zu Chips/URL).
    if (this._searchController) this._searchController.abort();
    const myController = new AbortController();
    this._searchController = myController;

    try {
      const resp = await fetch(`${baseUrl}/multi_search`, {
        method: 'POST',
        headers: {
          'X-TYPESENSE-API-KEY': TS_PAGE.searchKey,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ searches: [searchParams] }),
        signal: myController.signal,
      });

      if (!resp.ok) throw new Error(`Search failed: ${resp.status}`);
      const data = await resp.json();
      if (myController !== this._searchController) return;
      const result = data.results[0];
      console.log('[TS-SEARCH] Response: found=' + (result.found || 0) + ', hits=' + (result.hits || []).length + ', q=' + effectiveQ);

      if (result.error) throw new Error(result.error);

      // Nicht geführte Marke: Hits leeren, Facets behalten für Alternativen
      if (this._notCarriedBrand) {
        result.hits = [];
        result.found = 0;
      }

      this.totalFound = result.found || 0;

      // Analytics: Suchseiten-Ergebnis tracken (nur erste Seite)
      if (this.currentPage === 1) {
        trackPageSearch('search', this.query, { found: this.totalFound });
        if (this.totalFound === 0) {
          trackPageSearch('zero_result', this.query);
        }
      }

      this.renderResults(result);
      this.renderFacets(result.facet_counts || []);
      this.renderPagination();
      this.renderCount();
      this.updateUrl();
      this.revealContent();

    } catch (e) {
      // Absichtlich abgebrochene Requests (neuere Suche laeuft) sind kein Fehler
      if (e.name === 'AbortError') return;
      console.error('Typesense search error:', e);
      trackPageSearch('fallback', this.query, { reason: e.message || 'unknown' });
      this.showShopifyFallback();
      this.revealContent();
    } finally {
      // Spinner nur verstecken, wenn dieser Request noch der aktuelle ist —
      // sonst wuerde der Abbruch des alten den Spinner der neuen Suche killen
      if (myController === this._searchController && this.loadingEl) this.loadingEl.style.display = 'none';
    }
  }

  renderResults(result) {
    const hits = result.hits || [];
    if (!this.gridEl) return;

    // Stationäre Marke: nur im Ladengeschäft, Banner mit Mail-Anfrage.
    const storeOnly = detectStoreOnlyBrand(this.query);
    if (storeOnly) {
      this.renderStoreOnlyBanner(storeOnly);
      return;
    }

    // Partnershop-Match: Marken/Serien die wir nicht führen, aber premiumbags.com schon.
    // Treffer komplett ausblenden, stattdessen Hinweis-Banner mit Link.
    const partnershop = detectPartnershopBrand(this.query);
    if (partnershop) {
      this.renderPartnershopBanner(partnershop);
      return;
    }

    if (hits.length === 0) {
      // Service-Match (Retoure, Newsletter, Kontakt etc.) bei 0 Treffern: prominenten Banner zeigen
      const serviceLink = detectServiceLinkPage(this.query);
      if (serviceLink) {
        this.renderProminentServiceBanner(serviceLink);
        return;
      }
      this.gridEl.innerHTML = '';
      const sidebarContainer = this.gridEl.closest('.sidebar-container');
      if (sidebarContainer) {
        let noResultsEl = document.getElementById('ts-no-results');
        if (!noResultsEl) {
          noResultsEl = document.createElement('div');
          noResultsEl.id = 'ts-no-results';
          sidebarContainer.parentNode.insertBefore(noResultsEl, sidebarContainer);
        }
        noResultsEl.style.display = 'block';
        sidebarContainer.style.display = 'none';
        // Partnershop-/StoreOnly-Banner verstecken (Back/Forward-Navigation)
        const partnershopEl0 = document.getElementById('ts-partnershop-banner');
        if (partnershopEl0) partnershopEl0.style.display = 'none';
        const storeOnlyEl0 = document.getElementById('ts-storeonly-banner');
        if (storeOnlyEl0) storeOnlyEl0.style.display = 'none';
        // Fetch popular brands/categories for helpful alternatives
        this.renderNoResultsWithAlternatives(noResultsEl, result.facet_counts || []);
      }
      return;
    }

    // Ensure sidebar is visible and no-results is hidden when we have results
    const sidebarContainer = this.gridEl.closest('.sidebar-container');
    if (sidebarContainer) sidebarContainer.style.display = '';
    const noResultsEl = document.getElementById('ts-no-results');
    if (noResultsEl) noResultsEl.style.display = 'none';
    // Partnershop-/StoreOnly-Banner verstecken (bleiben sonst bei Back/Forward-Navigation stehen)
    const partnershopEl = document.getElementById('ts-partnershop-banner');
    if (partnershopEl) partnershopEl.style.display = 'none';
    const storeOnlyEl = document.getElementById('ts-storeonly-banner');
    if (storeOnlyEl) storeOnlyEl.style.display = 'none';

    // Service-Link Banner (Retoure, Kontakt, Versand) — auch bei Treffern anzeigen
    let serviceBannerEl = document.getElementById('ts-service-banner');
    const serviceLink = detectServiceLinkPage(this.query);
    if (serviceLink) {
      if (!serviceBannerEl) {
        serviceBannerEl = document.createElement('div');
        serviceBannerEl.id = 'ts-service-banner';
        this.gridEl.parentNode.insertBefore(serviceBannerEl, this.gridEl);
      }
      serviceBannerEl.style.display = 'block';
      serviceBannerEl.innerHTML = `<div style="margin-bottom:16px;padding:12px 16px;background:#f5f5f5;border-radius:8px;">
        <a href="${serviceLink.url}" style="display:flex;align-items:center;gap:10px;font-weight:600;font-size:15px;color:inherit;text-decoration:none;">
          <span style="font-size:20px;">&#128712;</span> ${this.escapeHtml(serviceLink.label)} &rarr;
        </a>
      </div>`;
    } else if (serviceBannerEl) {
      serviceBannerEl.style.display = 'none';
    }

    this.gridEl.classList.remove('loading');
    this.gridEl.innerHTML = hits.map(hit => this.renderProductCard(hit)).join('');

    // Worker Analytics: Klick auf Produktkarte tracken
    const searchQuery = this.query;
    const lang = (window.ISO_CODE || 'DE').toLowerCase();
    this.gridEl.querySelectorAll('li[data-ga4-id]').forEach(function(li) {
      li.addEventListener('click', function() {
        trackPageSearch('click', searchQuery, { product_id: li.dataset.ga4Id, lang: lang });
      });
    });
  }

  renderProductCard(hit) {
    const doc = hit.document;
    const rawTitle = doc.title || '';
    const vendor = doc.vendor || '';
    const vendorHandle = vendor.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '');

    let cleanedTitle = rawTitle;
    if (rawTitle.toLowerCase().startsWith(vendor.toLowerCase())) {
      cleanedTitle = rawTitle.slice(vendor.length).trim();
    }
    const displayTitle = cleanedTitle.length > 50 ? cleanedTitle.slice(0, 47) + '...' : cleanedTitle;

    const imgUrl = doc.image_url || '';
    const imgUrl2 = doc.image_url_2 || '';
    const productUrl = `/products/${doc.handle}`;

    const price = this.formatPrice(doc.price);
    const comparePrice = doc.compare_at_price ? this.formatPrice(doc.compare_at_price) : '';
    // UVP-Streichpreis bei jedem echten Rabatt zeigen (wie PDP/Collection/Autocomplete),
    // unabhaengig vom redaktionellen custom.status (SALE/Neu/Aktion/ohne).
    // UVP-Streichpreis + Rabatt-Badge fuer bestimmte Marken ausblenden (z.B. Ortlieb - keine UVP-Anzeige erlaubt).
    // Gleiche Liste wie in snippets/product-price.liquid.
    const UVP_HIDDEN_VENDORS = ['ortlieb'];
    const hideUvp = UVP_HIDDEN_VENDORS.includes((vendor || '').trim().toLowerCase());
    const hasDiscount = doc.compare_at_price && doc.compare_at_price > doc.price && !hideUvp;
    // Rotes -X%-Badge bleibt bewusst nur fuer offiziell als "SALE" markierte Produkte.
    const showSaleBadge = doc.custom_status === 'SALE' && hasDiscount;

    const bp = this.badgePosition;
    let badges = '';
    if (!doc.available) {
      badges += `<span class="badge out-of-stock ${bp}">${UI.soldOut}</span>`;
    } else if (showSaleBadge) {
      const savedPct = Math.round((doc.compare_at_price - doc.price) / doc.compare_at_price * 100);
      // Klasse "sale" (nicht "onsale") — passt zum Live-Theme. ".badge.onsale" ist
      // in so_custom.css per "display:none !important" versteckt.
      badges += `<span class="badge ${bp} sale">-${savedPct}%</span>`;
    }
    const saleBadge = `<span class="product-card--badges ${bp}">${badges}</span>`;
    const hasHover = imgUrl && imgUrl2;

    return `<li class="columns" data-ga4-id="${doc.id}" data-ga4-name="${this.escapeHtml(rawTitle)}" data-ga4-brand="${this.escapeHtml(vendor)}" data-ga4-type="${this.escapeHtml(doc.product_type || '')}" data-ga4-price="${doc.price || 0}"><product-card class="product-card text-left product-card--border-false">
  <figure class="product-card-image${hasHover ? ' thb-hover' : ''}">
    ${saleBadge}
    <a href="${productUrl}" title="${this.escapeHtml(rawTitle)}" class="product-card-image-link aspect-ratio aspect-ratio--square" style="--padding-bottom: 100%;">${imgUrl
        ? `<img class="product-primary-image" src="${this.resizeImg(imgUrl, '400x')}" srcset="${this.resizeImg(imgUrl, '200x')} 200w, ${this.resizeImg(imgUrl, '400x')} 400w, ${this.resizeImg(imgUrl, '600x')} 600w" sizes="(min-width: 1068px) 25vw, (min-width: 768px) 33vw, 50vw" alt="${this.escapeHtml(doc.image_alt || rawTitle)}" width="280" height="280">${hasHover ? `<img class="product-secondary-image" src="${this.resizeImg(imgUrl2, '400x')}" srcset="${this.resizeImg(imgUrl2, '200x')} 200w, ${this.resizeImg(imgUrl2, '400x')} 400w, ${this.resizeImg(imgUrl2, '600x')} 600w" sizes="(min-width: 1068px) 25vw, (min-width: 768px) 33vw, 50vw" alt="${this.escapeHtml(doc.image_alt || rawTitle)}" width="280" height="280">` : ''}`
        : `<div class="thb-placeholder"><svg viewBox="0 0 525 525" fill="none"><rect width="525" height="525" fill="#f5f5f5"/></svg></div>`
      }</a>
  </figure>
  <div class="product-card-info">
    <div class="product-card-info--inner">
      <div class="product-card-vendor"><a href="/collections/${vendorHandle}" title="${this.escapeHtml(vendor)}">${this.escapeHtml(vendor)}</a></div>
      <a href="${productUrl}" title="${this.escapeHtml(rawTitle)}" class="product-card-title">${this.escapeHtml(displayTitle)}</a>
      <span class="price">
        <ins><span class="amount">${price}</span></ins>
        ${hasDiscount ? `<del><span class="amount discounted">${comparePrice}</span></del>` : ''}
        <small class="unit-price hidden"><span></span><span class="unit-price-separator">/</span><span></span></small>
      </span>
      ${this.getParentTag(doc) ? `<collection-variant-selector data-parent="${this.escapeHtml(this.getParentTag(doc))}" class="product-sibling-wrapper"><div class="product-sibling-colors"></div><div class="product-sibling-images"></div></collection-variant-selector>` : ''}
    </div>
    <div class="product-card-info--bottom product-card-info--bottom-disabled">
      <a href="${productUrl}" class="button outline small product-card--view-details">${UI.details}</a>
    </div>
  </div>
</product-card>
</li>`;
  }

  /**
   * Smart facet ordering: sort facets by relevance to current search results.
   * - Pinned facets (vendor, suchfarbe) always first
   * - Bool facets (on_sale, vortasche) after regular facets
   * - Price always last
   * - Everything else sorted by number of distinct values with hits (more = more relevant)
   */
  sortFacetsByRelevance(facetCounts) {
    // Fixed best-practice order for luggage shop
    const FACET_ORDER = [
      'vendor', 'product_type', 'price', 'suchfarbe', 'groesse_gruppe',
      'volumen_gruppiert', 'material', 'gewicht_gruppiert', 'rollensystem',
      'gepaeckart', 'serie', 'ausstattung', 'rabatt_gruppe', 'on_sale',
      'vortasche', 'themenbereich', 'custom_status', 'gender'
    ];
    const orderMap = {};
    FACET_ORDER.forEach((f, i) => orderMap[f] = i);

    // Filter out boolean facets with no true values
    const boolFields = new Set(['on_sale', 'vortasche']);
    return facetCounts
      .filter(facet => {
        if (!boolFields.has(facet.field_name)) return true;
        return (facet.counts || []).some(c => (c.value === 'true' || c.value === true) && c.count > 0);
      })
      .sort((a, b) => (orderMap[a.field_name] ?? 99) - (orderMap[b.field_name] ?? 99));
  }

  renderActiveFilters() {
    const container = document.getElementById('ts-active-filters');
    if (!container) return;
    const activeEntries = Object.entries(this.activeFilters);

    if (activeEntries.length === 0 && !this.collectionTitle) {
      container.innerHTML = '';
      return;
    }

    let html = '<facet-remove class="active-facets">';
    // Collection-Filter als Chip anzeigen
    if (this.collectionTitle) {
      html += `<a href="#" class="active-facets__button ts-remove-collection">${this.escapeHtml(this.collectionTitle)} <span>${REMOVE_SVG}</span></a>`;
    }
    for (const [field, values] of activeEntries) {
      for (const val of values) {
        const displayVal = field === 'on_sale' ? UI.reduced : field === 'vortasche' ? UI.yes : this.escapeHtml(val);
        html += `<a href="#" class="active-facets__button ts-remove-filter" data-field="${field}" data-value="${this.escapeHtml(val)}">${displayVal} <span>${REMOVE_SVG}</span></a>`;
      }
    }
    html += `<a href="#" class="active-facets__button-remove text-button ts-clear-all">${UI.clearAll}</a>`;
    html += '</facet-remove>';

    container.innerHTML = html;

    // Bind remove events
    container.querySelectorAll('.ts-remove-filter').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const field = btn.dataset.field;
        const value = btn.dataset.value;
        this.activeFilters[field] = (this.activeFilters[field] || []).filter(v => v !== value);
        if (this.activeFilters[field].length === 0) delete this.activeFilters[field];
        this.cachedAiRewrite = null;
        this.currentPage = 1;
        this.search();
      });
    });
    // Collection-Filter entfernen
    container.querySelector('.ts-remove-collection')?.addEventListener('click', (e) => {
      e.preventDefault();
      this.collectionTitle = null;
      // URL aktualisieren (collection param entfernen)
      const url = new URL(window.location);
      url.searchParams.delete('collection');
      window.history.replaceState({}, '', url);
      this.cachedAiRewrite = null;
      this.currentPage = 1;
      this.search();
    });
    container.querySelector('.ts-clear-all')?.addEventListener('click', (e) => {
      e.preventDefault();
      this.activeFilters = {};
      this.collectionTitle = null;
      // URL aktualisieren
      const url = new URL(window.location);
      url.searchParams.delete('collection');
      window.history.replaceState({}, '', url);
      this.cachedAiRewrite = null;
      this.currentPage = 1;
      this.search();
    });
  }

  renderFacets(facetCounts) {
    if (!this.facetsEl) return;

    const sortedFacets = this.sortFacetsByRelevance(facetCounts);

    let html = '<div class="facets__wrapper">';
    let idx = 1;

    for (const facet of sortedFacets) {
      const field = facet.field_name;
      const label = FACET_LABELS[field] || field;
      let counts = facet.counts || [];
      if (counts.length === 0) continue;

      // Price: render as range filter instead of checkboxes
      if (field === 'price' && facet.stats) {
        html += this.renderPriceRangeFilter(facet.stats, idx);
        idx++;
        continue;
      }

      // on_sale / vortasche: only show true value
      if (field === 'on_sale' || field === 'vortasche') {
        counts = counts.filter(c => c.value === 'true' || c.value === true);
        if (counts.length === 0) continue;
      }

      // groesse_gruppe: sort logically (Handgepäck -> Mittelgroß -> Groß -> XL -> Set)
      if (field === 'groesse_gruppe') {
        const order = { 'Handgepäck (bis 55 cm)': 0, 'Mittelgroß (56-69 cm)': 1, 'Groß (70-79 cm)': 2, 'XL (ab 80 cm)': 3, 'Set': 4 };
        counts = [...counts].sort((a, b) => (order[a.value] ?? 9) - (order[b.value] ?? 9));
      }

      // rabatt_gruppe: sort by discount ascending
      if (field === 'rabatt_gruppe') {
        const order = { '5-10%': 0, '10-20%': 1, '20-30%': 2, '30-40%': 3, '40-50%': 4, '50%+': 5 };
        counts = [...counts].sort((a, b) => (order[a.value] ?? 9) - (order[b.value] ?? 9));
      }

      const activeVals = this.activeFilters[field] || [];
      const isOpen = activeVals.length > 0 || idx <= 4;
      const filterSize = counts.length;
      const hasHidden = filterSize > 5;
      const slug = SLUG_MAP[field] || field.replace(/[^a-z0-9]/gi, '-').toLowerCase();
      const isColor = slug === 'color';

      html += `<collapsible-row data-index="${idx}">
<details class="thb-filter js-filter"${isOpen ? ' open' : ''}>
<summary class="thb-filter-title">${this.escapeHtml(label)} <span>${ARROW_SVG}</span></summary>
<div class="thb-filter-content collapsible__content${hasHidden ? ' thb-filter-content--has-button' : ''}">
<ul class="list-${slug}">`;

      for (let i = 0; i < counts.length; i++) {
        const c = counts[i];
        if (!c.value && c.value !== false) continue;
        const val = String(c.value);
        const checked = activeVals.includes(val);
        const disabled = c.count === 0 && !checked;
        const hidden = i >= 5;
        const id = `Filter-${slug}-${i + 1}`;
        const displayVal = field === 'on_sale' ? UI.reduced : field === 'vortasche' ? UI.yes : this.escapeHtml(val);

        let labelClass = 'facet-checkbox';
        if (disabled) labelClass += ' facet-checkbox--disabled';

        let styleAttr = '';
        if (isColor) {
          const colorKey = val.toLowerCase().replace(/\s+/g, '');
          const cssColor = COLOR_MAP[colorKey] || val.toLowerCase();
          styleAttr = ` style="--bg-color: ${this.escapeHtml(cssColor)};"`;
        }

        html += `<li${hidden ? ' class="thb-filter-content--hidden"' : ''}>`;
        html += `<input type="checkbox" id="${id}" ${checked ? 'checked' : ''}${disabled ? ' disabled' : ''} data-field="${field}" data-value="${this.escapeHtml(val)}">`;
        html += `<label for="${id}" class="${labelClass}"${styleAttr} data-tooltip="${displayVal} (${c.count})">`;
        html += `<span class="thb-filter-text">${displayVal}</span><span class="count">${c.count}</span>`;
        html += `</label></li>`;
      }

      html += `</ul>`;

      if (hasHidden) {
        html += `<more-filters class="thb-filter-content--button text-button" data-field="${field}">${UI.showMore}</more-filters>`;
      }

      html += `</div>
</details>
</collapsible-row>`;
      idx++;
    }

    html += '</div>';
    this.facetsEl.innerHTML = html;

    // Active filters bar (tags to remove individual filters)
    this.renderActiveFilters();

    // Mobile drawer: Sort + Facets
    if (this.mobileFacetsEl) {
      // Sortierung als erste Sektion (wie Collection-Page Standard)
      let mobileHtml = '<div class="facets__wrapper">';
      mobileHtml += '<collapsible-row data-index="0"><details class="thb-filter js-filter" open>';
      mobileHtml += '<summary class="thb-filter-title">' + UI.sortBy + ' <span>' + ARROW_SVG + '</span></summary>';
      mobileHtml += '<div class="thb-filter-content collapsible__content"><ul class="list-sort">';
      for (let si = 0; si < SORT_OPTIONS.length; si++) {
        const opt = SORT_OPTIONS[si];
        const checked = opt.value === this.sortBy;
        mobileHtml += '<li><input type="radio" name="ts-mobile-sort" id="m-sort-' + si + '" value="' + opt.value + '"' + (checked ? ' checked' : '') + '>';
        mobileHtml += '<label for="m-sort-' + si + '" class="facet-checkbox">';
        mobileHtml += '<span class="thb-filter-text">' + this.escapeHtml(opt.label) + '</span></label></li>';
      }
      mobileHtml += '</ul></div></details></collapsible-row></div>';
      this.mobileFacetsEl.innerHTML = mobileHtml + html;
      // Sync mobile checkboxes with desktop state and add events
      this.mobileFacetsEl.querySelectorAll('input[type="checkbox"]').forEach(cb => {
        // Unique mobile ID to avoid duplicate IDs
        cb.id = 'm-' + cb.id;
        const label = cb.nextElementSibling;
        if (label) label.setAttribute('for', cb.id);
        cb.addEventListener('change', (e) => {
          const field = e.target.dataset.field;
          const value = e.target.dataset.value;
          if (e.target.checked) {
            if (!this.activeFilters[field]) this.activeFilters[field] = [];
            this.activeFilters[field].push(value);
          } else {
            this.activeFilters[field] = (this.activeFilters[field] || []).filter(v => v !== value);
            if (this.activeFilters[field].length === 0) delete this.activeFilters[field];
          }
          this.currentPage = 1;
          this.search();
        });
      });
      // Mobile sort: Radio-Buttons -> Sortierung aendern
      this.mobileFacetsEl.querySelectorAll('input[name="ts-mobile-sort"]').forEach(radio => {
        radio.addEventListener('change', (e) => {
          this.sortBy = e.target.value;
          if (this.sortEl) this.sortEl.value = this.sortBy;
          this.currentPage = 1;
          this.search();
        });
      });
      // Mobile price slider: rename IDs and init separately
      const mSlider = this.mobileFacetsEl.querySelector('#ts-price-nouislider');
      if (mSlider) {
        mSlider.id = 'm-ts-price-nouislider';
        const mWrapper = this.mobileFacetsEl.querySelector('#ts-price-slider');
        if (mWrapper) mWrapper.id = 'm-ts-price-slider';
        const mMin = this.mobileFacetsEl.querySelector('#ts-price-min');
        const mMax = this.mobileFacetsEl.querySelector('#ts-price-max');
        if (mMin) mMin.id = 'm-ts-price-min';
        if (mMax) mMax.id = 'm-ts-price-max';
        this.initMobilePriceFilter(mSlider, mMin, mMax);
      }
      // Mobile more-filters buttons
      this.mobileFacetsEl.querySelectorAll('more-filters').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          const ul = btn.closest('.thb-filter-content').querySelector('ul');
          if (ul.hasAttribute('filters-open')) {
            btn.textContent = UI.showMore;
            ul.removeAttribute('filters-open');
          } else {
            btn.textContent = UI.showLess;
            ul.setAttribute('filters-open', '');
          }
        });
      });
    }

    // Register custom elements if not already defined
    if (!customElements.get('more-filters')) {
      customElements.define('more-filters', class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', (e) => {
            e.preventDefault();
            const ul = this.closest('.thb-filter-content').querySelector('ul');
            if (ul.hasAttribute('filters-open')) {
              this.textContent = UI.showMore;
              ul.removeAttribute('filters-open');
            } else {
              this.textContent = UI.showLess;
              ul.setAttribute('filters-open', '');
            }
          });
        }
      });
    }
    if (!customElements.get('sidebar-toggle')) {
      customElements.define('sidebar-toggle', class extends HTMLElement {
        connectedCallback() {
          const span = this.querySelector('span');
          if (!span) return;
          const hideText = span.textContent;
          this.addEventListener('click', (e) => {
            e.preventDefault();
            const drawer = document.getElementById('Sidebar-Container');
            if (!drawer) return;
            drawer.classList.toggle('facets--sidebar-open');
            span.textContent = drawer.classList.contains('facets--sidebar-open') ? hideText : UI.showFilters;
          });
        }
      });
    }
    if (!customElements.get('facet-toggle')) {
      customElements.define('facet-toggle', class extends HTMLElement {
        connectedCallback() {
          this.addEventListener('click', () => {
            const drawer = document.getElementById('ts-mobile-drawer');
            if (!drawer) return;
            // Scroll-Position merken und Body fixieren
            const scrollY = window.scrollY;
            document.documentElement.style.setProperty('--ts-scroll-y', `-${scrollY}px`);
            document.body.classList.add('open-cc', 'ts-drawer-open');
            document.body.dataset.tsScrollY = scrollY;
            drawer.classList.add('active');
            drawer.removeAttribute('inert');
          });
        }
      });
    }

    // Drawer schliessen: Body-Scroll wiederherstellen
    function closeTsDrawer() {
      document.body.classList.remove('ts-drawer-open');
      const scrollY = parseInt(document.body.dataset.tsScrollY || '0');
      document.documentElement.style.removeProperty('--ts-scroll-y');
      window.scrollTo(0, scrollY);
    }

    // Mobile drawer: apply button closes drawer
    const mobileApplyBtn = document.getElementById('ts-mobile-apply-btn');
    if (mobileApplyBtn && !mobileApplyBtn._tsInit) {
      mobileApplyBtn._tsInit = true;
      mobileApplyBtn.addEventListener('click', () => {
        closeTsDrawer();
        const cc = document.querySelector('.click-capture');
        if (cc) cc.click(); // Triggers PanelClose which handles cleanup
      });
    }

    // Auch bei click-capture (Overlay) und ESC den Scroll-Lock entfernen
    const cc = document.querySelector('.click-capture');
    if (cc && !cc._tsInit) {
      cc._tsInit = true;
      cc.addEventListener('click', closeTsDrawer);
    }
    document.addEventListener('panel:close', closeTsDrawer);

    // Price range filter
    this.initPriceFilter();

    // Checkbox Filter Events (desktop)
    this.facetsEl.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      cb.addEventListener('change', (e) => {
        const field = e.target.dataset.field;
        const value = e.target.dataset.value;
        if (e.target.checked) {
          if (!this.activeFilters[field]) this.activeFilters[field] = [];
          this.activeFilters[field].push(value);
        } else {
          this.activeFilters[field] = (this.activeFilters[field] || []).filter(v => v !== value);
          if (this.activeFilters[field].length === 0) delete this.activeFilters[field];
        }
        this.currentPage = 1;
        this.search();
      });
    });
  }


  renderPagination() {
    if (!this.paginationEl) return;
    const totalPages = Math.ceil(this.totalFound / this.perPage);
    const start = (this.currentPage - 1) * this.perPage + 1;
    const end = Math.min(this.currentPage * this.perPage, this.totalFound);
    const progress = this.totalFound > 0 ? (end / this.totalFound) : 0;

    let html = `<div class="thb-filter-count" id="ProductCount">
      <span class="facets__label">${start}-${end} / ${this.totalFound.toLocaleString(TS_LANG)} ${UI.products}</span>
      <div class="pagination--progress" style="--progress-count: ${progress};"><div class="pagination--progress-bar"></div></div>
    </div>`;

    if (totalPages > 1) {
      html += `<pagination-theme class="pagination pagination-type--paginated">
        <div class="row">
          <div class="small-12 columns">
            <ul class="page-numbers nav-links">`;

      html += `<li class="prev${this.currentPage <= 1 ? ' disabled' : ''}">`;
      if (this.currentPage > 1) {
        const prevUrl = this.escapeHtml(this.buildUrlForPage(this.currentPage - 1));
        html += `<a href="${prevUrl}" class="ts-page-link" data-page="${this.currentPage - 1}" rel="prev">&laquo;</a>`;
      } else {
        html += `<span>&laquo;</span>`;
      }
      html += `</li>`;

      const pages = this.getPageRange(this.currentPage, totalPages);
      for (const p of pages) {
        if (p === '...') {
          html += `<li class="ellip"><span>&hellip;</span></li>`;
        } else if (p === this.currentPage) {
          html += `<li class="current"><span>${p}</span></li>`;
        } else {
          const pageUrl = this.escapeHtml(this.buildUrlForPage(p));
          html += `<li class="page"><a href="${pageUrl}" class="ts-page-link" data-page="${p}">${p}</a></li>`;
        }
      }

      html += `<li class="next${this.currentPage >= totalPages ? ' disabled' : ''}">`;
      if (this.currentPage < totalPages) {
        const nextUrl = this.escapeHtml(this.buildUrlForPage(this.currentPage + 1));
        html += `<a href="${nextUrl}" class="ts-page-link" data-page="${this.currentPage + 1}" rel="next">&raquo;</a>`;
      } else {
        html += `<span>&raquo;</span>`;
      }
      html += `</li></ul></div></div></pagination-theme>`;
    }

    this.paginationEl.innerHTML = html;

    this.paginationEl.querySelectorAll('.ts-page-link').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const page = parseInt(e.currentTarget.dataset.page);
        if (!page || page === this.currentPage) return;
        this.currentPage = page;
        if (this.gridEl) {
          this.gridEl.classList.add('loading');
          const top = this.gridEl.getBoundingClientRect().top + window.scrollY - parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '0', 10) - 30;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
        this.search();
      });
    });
  }

  getPageRange(current, total) {
    if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
    const pages = [];
    pages.push(1);
    if (current > 3) pages.push('...');
    for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
      pages.push(i);
    }
    if (current < total - 2) pages.push('...');
    pages.push(total);
    return pages;
  }

  renderCount() {
    const countText = `${this.totalFound.toLocaleString(TS_LANG)} ${UI.products}`;
    if (this.countEl) {
      this.countEl.textContent = countText;
    }
    const bannerDesc = document.getElementById('search-results-description');
    if (bannerDesc) {
      bannerDesc.textContent = `${this.totalFound.toLocaleString(TS_LANG)} ${UI.resultsFor} \u201e${this.query}\u201c`;
    }
    // Shopify's serverseitige Ergebnis-Anzahl im Collection-Banner ueberschreiben
    const collBanner = document.querySelector('.collection-banner--description');
    if (collBanner) {
      const p = collBanner.querySelector('p');
      if (p) p.textContent = `${this.totalFound.toLocaleString(TS_LANG)} ${UI.resultsFor} \u201e${this.query}\u201c`;
    }
    // Document Title aktualisieren (UX: Browser-Tab + Bookmark)
    const baseTitle = this._baseTitle || (this._baseTitle = document.title.split(' \u2013 ').pop() || 'Markenkoffer');
    const pageSuffix = this.currentPage > 1 ? ` (Seite ${this.currentPage})` : '';
    document.title = `${this.totalFound.toLocaleString(TS_LANG)} ${UI.resultsFor} \u201e${this.query}\u201c${pageSuffix} \u2013 ${baseTitle}`;
  }

  buildUrlForPage(page) {
    const params = new URLSearchParams();
    params.set('q', this.query);
    if (this.collectionTitle) {
      params.set('collection', this.collectionTitle);
    }
    for (const [field, values] of Object.entries(this.activeFilters)) {
      params.set(`ts_f_${field}`, values.join(','));
    }
    if (this.sortBy !== '_text_match:desc,boost_score:desc') {
      params.set('ts_sort', this.sortBy);
    }
    if (page && page > 1) {
      params.set('page', page);
    }
    return `${window.location.pathname}?${params.toString()}`;
  }

  updateUrl() {
    const newUrl = this.buildUrlForPage(this.currentPage);
    if (newUrl !== window.location.pathname + window.location.search) {
      history.pushState(null, '', newUrl);
    }
  }

  // --- KI Widget ---

  isNaturalLanguage(q) {
    if (!q || q.split(/\s+/).length < 3) return false;
    return /\b(fuer|für|unter|ueber|über|bis|ab|mit|ohne|zum|zur|suche|brauche|welche?[nrsm]?|bester?|guenstig|günstig|billig|teuer|leicht|schwer|groß|gross|klein|woche|urlaub|reise|flug|geschenk|empfehl|wandern|schule|arbeit|business|kinder|damen|herren|laptop|handgepaeck|handgepäck)\b/i.test(q);
  }

  initAiWidget() {
    const widget = document.getElementById('ts-ai-widget');
    if (!widget) return;

    // Show hint only for natural language queries
    if (!this.isNaturalLanguage(this.query)) return;

    widget.style.display = 'block';

    // Set translated text
    const hintText = widget.querySelector('.ts-ai-hint-text');
    if (hintText) hintText.innerHTML = UI.aiDetected;
    const labelEl = widget.querySelector('.ts-ai-label');
    if (labelEl) labelEl.innerHTML = `&#129504; ${UI.aiLabel}`;

    const loadBtn = document.getElementById('ts-ai-load-btn');
    const sendBtn = document.getElementById('ts-ai-send-btn');
    const inputEl = document.getElementById('ts-ai-input');

    if (loadBtn) loadBtn.textContent = UI.aiLoad;
    if (sendBtn) sendBtn.textContent = UI.aiSend;
    if (inputEl) inputEl.placeholder = UI.aiFollowup;

    if (loadBtn) {
      loadBtn.addEventListener('click', () => {
        this.loadAiRecommendation(this.query);
      });
    }

    if (sendBtn && inputEl) {
      sendBtn.addEventListener('click', () => {
        const followUp = inputEl.value.trim();
        if (followUp) this.sendFollowUp(followUp);
      });
      inputEl.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          const followUp = inputEl.value.trim();
          if (followUp) this.sendFollowUp(followUp);
        }
      });
    }
  }

  async loadAiRecommendation(question, isFollowUp) {
    const hintEl = document.getElementById('ts-ai-hint');
    const answerEl = document.getElementById('ts-ai-answer');
    const textEl = document.getElementById('ts-ai-text');
    if (!hintEl || !answerEl || !textEl) return;

    // Show loading state
    if (!isFollowUp) {
      hintEl.innerHTML = '<span class="ts-ai-hint-icon">&#129504;</span><span class="ts-ai-loading">' + UI.aiLoading + '</span>';
    }

    const aiAdvisorUrl = 'https://ai-advisor.markenkoffer.de/advisor';

    try {
      const resp = await fetch(aiAdvisorUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          question,
          session_id: this.conversationId || undefined,
          language: (typeof TS_LANG !== 'undefined' ? TS_LANG : 'de'),
        }),
      });

      const data = await resp.json();

      if (data.error || !data.answer) {
        if (!isFollowUp) {
          hintEl.innerHTML = '<span class="ts-ai-hint-icon">&#129504;</span><span class="ts-ai-hint-text">' + (data.error || UI.aiNoAnswer) + '</span>';
        } else {
          this.aiMessages.push({ role: 'ai', html: '<em>' + (data.error || UI.aiNoAnswer) + '</em>' });
          this.renderAiMessages(textEl);
        }
        return;
      }

      // Store session ID for follow-ups
      if (data.session_id) {
        this.conversationId = data.session_id;
      }

      const products = (data.products || []).map(p => ({ document: p }));
      const formattedAnswer = this.formatAiAnswer(data.answer, products);

      // Accumulate messages
      this.aiMessages.push({ role: 'ai', html: formattedAnswer });

      hintEl.style.display = 'none';
      answerEl.style.display = 'block';
      this.renderAiMessages(textEl);

    } catch (e) {
      console.error('AI recommendation error:', e);
      if (!isFollowUp) {
        hintEl.innerHTML = '<span class="ts-ai-hint-icon">&#129504;</span><span class="ts-ai-hint-text">' + UI.aiError + '</span>';
      } else {
        this.aiMessages.push({ role: 'ai', html: '<em>Fehler beim Laden. Bitte erneut versuchen.</em>' });
        this.renderAiMessages(textEl);
      }
    }
  }

  renderAiMessages(textEl) {
    textEl.innerHTML = this.aiMessages.map(m => {
      if (m.role === 'user') return `<div class="ts-ai-user-msg"><strong>Sie:</strong> ${m.html}</div>`;
      return `<div class="ts-ai-bot-msg">${m.html}</div>`;
    }).join('');
  }

  async sendFollowUp(question) {
    const textEl = document.getElementById('ts-ai-text');
    const inputEl = document.getElementById('ts-ai-input');
    const sendBtn = document.getElementById('ts-ai-send-btn');
    if (!textEl || !inputEl) return;

    // Add user question to messages
    this.aiMessages.push({ role: 'user', html: this.escapeHtml(question) });
    this.renderAiMessages(textEl);

    // Add loading indicator
    textEl.innerHTML += '<div class="ts-ai-loading">' + UI.aiAnswerLoading + '</div>';

    inputEl.value = '';
    if (sendBtn) sendBtn.disabled = true;

    await this.loadAiRecommendation(question, true);

    if (sendBtn) sendBtn.disabled = false;
    inputEl.focus();
  }

  formatAiAnswer(answer, hits) {
    let html = answer.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    html = html.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    html = html.replace(/\n/g, '<br>');

    for (let i = 0; i < hits.length; i++) {
      const doc = hits[i].document;
      const t = doc.title.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const base = doc.title.split(' - ')[0].replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      const link = `<a href="/products/${doc.handle}">${t}</a>`;
      const baseLink = `<a href="/products/${doc.handle}">${base}</a>`;
      if (html.indexOf(t) > -1) {
        html = html.replace(t, link);
      } else if (html.indexOf(base) > -1) {
        html = html.replace(base, baseLink);
      }
    }

    return html;
  }

  // --- Price Range Filter ---

  renderPriceRangeFilter(stats, idx) {
    const min = 0;
    const max = Math.ceil(stats.max || 1000);
    const activePrice = this.activeFilters['price'] || [];
    let curMin = min, curMax = max;
    if (activePrice.length === 1) {
      const m = activePrice[0].match(/\[(\d+)\.\.(\d+)\]/);
      if (m) { curMin = parseInt(m[1]); curMax = parseInt(m[2]); }
    }

    return `<collapsible-row data-index="${idx}">
<details class="thb-filter js-filter" open>
<summary class="thb-filter-title">${FACET_LABELS['price'] || 'Preis'} <span>${ARROW_SVG}</span></summary>
<div class="thb-filter-content collapsible__content">
<div class="price_range price_range-preis">
<span class="price-highest">${UI.maxPrice}: ${this.formatPrice(max)}</span>
<div class="price_slider_wrapper" id="ts-price-slider">
<div class="price_slider" id="ts-price-nouislider"
  data-min="${min}" data-max="${max}"
  data-cur-min="${curMin}" data-cur-max="${curMax}">
</div>
<div class="price_slider_amount">
<div>
<span class="field-currency">\u20ac</span>
<input class="field__input field__input_min" type="text" value="${curMin > min ? curMin : ''}" placeholder="0" id="ts-price-min">
</div>
<div>
<span class="field-currency">\u20ac</span>
<input class="field__input field__input_max" type="text" value="${curMax < max ? curMax : ''}" placeholder="${max}" id="ts-price-max">
</div>
</div>
</div>
</div>
</div>
</details>
</collapsible-row>`;
  }

  initPriceFilter() {
    const sliderEl = document.getElementById('ts-price-nouislider');
    if (!sliderEl || typeof noUiSlider === 'undefined') return;

    const min = parseFloat(sliderEl.dataset.min) || 0;
    const max = parseFloat(sliderEl.dataset.max) || 1000;
    const curMin = parseFloat(sliderEl.dataset.curMin) || min;
    const curMax = parseFloat(sliderEl.dataset.curMax) || max;
    const minEl = document.getElementById('ts-price-min');
    const maxEl = document.getElementById('ts-price-max');

    // Destroy existing slider if re-rendering
    if (sliderEl.noUiSlider) sliderEl.noUiSlider.destroy();

    noUiSlider.create(sliderEl, {
      start: [curMin, curMax],
      connect: true,
      step: 10,
      direction: document.dir || 'ltr',
      range: { min, max }
    });

    // Update input fields on slider drag
    sliderEl.noUiSlider.on('update', (values) => {
      if (minEl) minEl.value = Math.round(parseFloat(values[0]));
      if (maxEl) maxEl.value = Math.round(parseFloat(values[1]));
    });

    // Trigger search on slider release
    sliderEl.noUiSlider.on('change', (values) => {
      const minVal = Math.round(parseFloat(values[0]));
      const maxVal = Math.round(parseFloat(values[1]));
      if (minVal > min || maxVal < max) {
        this.activeFilters['price'] = [`[${minVal}..${maxVal}]`];
      } else {
        delete this.activeFilters['price'];
      }
      this.currentPage = 1;
      this.search();
    });

    // Support manual input in text fields
    const applyFromInputs = () => {
      const minVal = parseInt(minEl.value) || 0;
      const maxVal = parseInt(maxEl.value) || max;
      sliderEl.noUiSlider.set([minVal, maxVal]);
      if (minVal > min || maxVal < max) {
        this.activeFilters['price'] = [`[${minVal}..${maxVal}]`];
      } else {
        delete this.activeFilters['price'];
      }
      this.currentPage = 1;
      this.search();
    };
    if (minEl) minEl.addEventListener('change', applyFromInputs);
    if (maxEl) maxEl.addEventListener('change', applyFromInputs);
  }

  initMobilePriceFilter(sliderEl, minEl, maxEl) {
    if (!sliderEl || typeof noUiSlider === 'undefined') return;
    const min = parseFloat(sliderEl.dataset.min) || 0;
    const max = parseFloat(sliderEl.dataset.max) || 1000;
    const curMin = parseFloat(sliderEl.dataset.curMin) || min;
    const curMax = parseFloat(sliderEl.dataset.curMax) || max;
    if (sliderEl.noUiSlider) sliderEl.noUiSlider.destroy();
    noUiSlider.create(sliderEl, {
      start: [curMin, curMax], connect: true, step: 10,
      direction: document.dir || 'ltr', range: { min, max }
    });
    sliderEl.noUiSlider.on('update', (values) => {
      if (minEl) minEl.value = Math.round(parseFloat(values[0]));
      if (maxEl) maxEl.value = Math.round(parseFloat(values[1]));
    });
    sliderEl.noUiSlider.on('change', (values) => {
      const minVal = Math.round(parseFloat(values[0]));
      const maxVal = Math.round(parseFloat(values[1]));
      if (minVal > min || maxVal < max) {
        this.activeFilters['price'] = [`[${minVal}..${maxVal}]`];
      } else {
        delete this.activeFilters['price'];
      }
      this.currentPage = 1;
      this.search();
    });
    const applyFromInputs = () => {
      const minVal = parseInt(minEl.value) || 0;
      const maxVal = parseInt(maxEl.value) || max;
      sliderEl.noUiSlider.set([minVal, maxVal]);
      if (minVal > min || maxVal < max) {
        this.activeFilters['price'] = [`[${minVal}..${maxVal}]`];
      } else {
        delete this.activeFilters['price'];
      }
      this.currentPage = 1;
      this.search();
    };
    if (minEl) minEl.addEventListener('change', applyFromInputs);
    if (maxEl) maxEl.addEventListener('change', applyFromInputs);
  }

  // --- Helpers ---

  resizeImg(url, size) {
    // Shopify CDN: insert _WIDTHx before extension, handles both ?v= and no-query URLs
    return url.replace(/\.([a-z]+)(\?|$)/, `_${size}.$1$2`);
  }

  getParentTag(doc) {
    if (!doc.tags || !Array.isArray(doc.tags)) return null;
    const parentTag = doc.tags.find(t => t.startsWith('parent:'));
    return parentTag ? parentTag.replace('parent:', '') : null;
  }

  formatPrice(price) {
    const localeMap = { de:'de-DE', en:'en-GB', fr:'fr-FR', it:'it-IT', es:'es-ES', nl:'nl-NL' };
    return new Intl.NumberFormat(localeMap[TS_LANG] || 'de-DE', { style: 'currency', currency: 'EUR' }).format(price);
  }

  escapeHtml(text) {
    if (!text) return '';
    const d = document.createElement('div');
    d.textContent = text;
    return d.innerHTML.replace(/"/g, '&quot;');
  }

  renderProminentServiceBanner(serviceLink) {
    this.gridEl.innerHTML = '';
    const sidebarContainer = this.gridEl.closest('.sidebar-container');
    let containerEl = document.getElementById('ts-service-prominent-banner');
    if (!containerEl) {
      containerEl = document.createElement('div');
      containerEl.id = 'ts-service-prominent-banner';
      const insertBefore = sidebarContainer || this.gridEl;
      insertBefore.parentNode.insertBefore(containerEl, insertBefore);
    }
    if (sidebarContainer) sidebarContainer.style.display = 'none';
    const noResultsEl = document.getElementById('ts-no-results');
    if (noResultsEl) noResultsEl.style.display = 'none';
    if (this.paginationEl) this.paginationEl.innerHTML = '';
    if (this.countEl) this.countEl.textContent = '';

    containerEl.style.display = 'block';
    containerEl.innerHTML = `<div style="padding:48px 24px 40px;max-width:720px;margin:0 auto;text-align:center;">
      <div style="font-size:42px;line-height:1;margin-bottom:16px;">&#128712;</div>
      <h2 style="font-size:22px;font-weight:600;margin:0 0 24px;line-height:1.3;">${this.escapeHtml(serviceLink.label)}</h2>
      <a href="${serviceLink.url}"
         style="display:inline-flex;align-items:center;gap:8px;padding:14px 28px;background:#000;color:#fff;font-weight:600;font-size:15px;border-radius:999px;text-decoration:none;transition:opacity .15s;"
         onmouseover="this.style.opacity='0.85';" onmouseout="this.style.opacity='1';">
        ${this.escapeHtml(serviceLink.label)} &rarr;
      </a>
    </div>`;

    trackPageSearch('service_redirect_shown', this.query, { url: serviceLink.url });
    containerEl.querySelector('a').addEventListener('click', () => {
      trackPageSearch('service_redirect_click', this.query, { url: serviceLink.url });
    });
  }

  renderStoreOnlyBanner(storeOnly) {
    this.gridEl.innerHTML = '';
    const sidebarContainer = this.gridEl.closest('.sidebar-container');
    let containerEl = document.getElementById('ts-storeonly-banner');
    if (!containerEl) {
      containerEl = document.createElement('div');
      containerEl.id = 'ts-storeonly-banner';
      const insertBefore = sidebarContainer || this.gridEl;
      insertBefore.parentNode.insertBefore(containerEl, insertBefore);
    }
    if (sidebarContainer) sidebarContainer.style.display = 'none';
    const noResultsEl = document.getElementById('ts-no-results');
    if (noResultsEl) noResultsEl.style.display = 'none';
    const partnershopEl = document.getElementById('ts-partnershop-banner');
    if (partnershopEl) partnershopEl.style.display = 'none';
    const serviceBannerEl = document.getElementById('ts-service-banner');
    if (serviceBannerEl) serviceBannerEl.style.display = 'none';
    if (this.paginationEl) this.paginationEl.innerHTML = '';
    if (this.countEl) this.countEl.textContent = '';

    const brand = this.escapeHtml(storeOnly.displayBrand);
    const header = UI.storeOnlyHeader.replace('{brand}', brand);
    const hint = UI.storeOnlyHint;
    const subject = encodeURIComponent(`Anfrage ${storeOnly.displayBrand}`);
    const mailto = `mailto:${STORE_ONLY_MAIL}?subject=${subject}`;
    containerEl.style.display = 'block';
    containerEl.innerHTML = `<div style="padding:48px 24px 40px;max-width:720px;margin:0 auto;text-align:center;">
      <div style="font-size:42px;line-height:1;margin-bottom:16px;">&#127978;</div>
      <h2 style="font-size:22px;font-weight:600;margin:0 0 8px;line-height:1.3;">${header}</h2>
      <p style="color:rgba(0,0,0,.65);margin:0 0 24px;font-size:15px;">${hint}</p>
      <a href="${mailto}"
         style="display:inline-flex;align-items:center;gap:8px;padding:14px 28px;background:#000;color:#fff;font-weight:600;font-size:15px;border-radius:999px;text-decoration:none;transition:opacity .15s;"
         onmouseover="this.style.opacity='0.85';" onmouseout="this.style.opacity='1';">
        &#9993; ${UI.storeOnlyCta}
      </a>
    </div>`;

    trackPageSearch('storeonly_shown', this.query, { brand: storeOnly.displayBrand });
    containerEl.querySelector('a').addEventListener('click', () => {
      trackPageSearch('storeonly_mail_click', this.query, { brand: storeOnly.displayBrand });
    });
  }

  renderPartnershopBanner(partnershop) {
    // Treffer ausblenden, Sidebar verstecken, Banner anzeigen.
    this.gridEl.innerHTML = '';
    const sidebarContainer = this.gridEl.closest('.sidebar-container');
    let containerEl = document.getElementById('ts-partnershop-banner');
    if (!containerEl) {
      containerEl = document.createElement('div');
      containerEl.id = 'ts-partnershop-banner';
      const insertBefore = sidebarContainer || this.gridEl;
      insertBefore.parentNode.insertBefore(containerEl, insertBefore);
    }
    if (sidebarContainer) sidebarContainer.style.display = 'none';
    const noResultsEl = document.getElementById('ts-no-results');
    if (noResultsEl) noResultsEl.style.display = 'none';
    const serviceBannerEl = document.getElementById('ts-service-banner');
    if (serviceBannerEl) serviceBannerEl.style.display = 'none';
    const storeOnlyBannerEl = document.getElementById('ts-storeonly-banner');
    if (storeOnlyBannerEl) storeOnlyBannerEl.style.display = 'none';
    if (this.paginationEl) this.paginationEl.innerHTML = '';
    if (this.countEl) this.countEl.textContent = '';

    const brand = this.escapeHtml(partnershop.displayBrand);
    const header = UI.partnershopHeader.replace('{brand}', brand);
    const hint = UI.partnershopHint.replace('{brand}', brand);
    containerEl.style.display = 'block';
    containerEl.innerHTML = `<div style="padding:48px 24px 40px;max-width:720px;margin:0 auto;text-align:center;">
      <div style="font-size:42px;line-height:1;margin-bottom:16px;">&#128717;</div>
      <h2 style="font-size:22px;font-weight:600;margin:0 0 8px;line-height:1.3;">${header}</h2>
      <p id="ts-partnershop-hint" style="color:rgba(0,0,0,.65);margin:0 0 24px;font-size:15px;">${hint}</p>
      <div id="ts-partnershop-products" style="display:none;grid-template-columns:repeat(auto-fit,minmax(150px,1fr));gap:12px;max-width:640px;margin:0 auto 22px;"></div>
      <a href="${partnershop.url}" target="_blank" rel="noopener noreferrer"
         style="display:inline-flex;align-items:center;gap:8px;padding:14px 28px;background:#000;color:#fff;font-weight:600;font-size:15px;border-radius:999px;text-decoration:none;transition:opacity .15s;"
         onmouseover="this.style.opacity='0.85';" onmouseout="this.style.opacity='1';">
        ${UI.partnershopCta} &rarr;
      </a>
      <div id="ts-partnershop-trust" style="color:rgba(0,0,0,.5);font-size:13px;margin-top:14px;"></div>
    </div>`;

    trackPageSearch('partnershop_redirect_shown', this.query, { brand: partnershop.displayBrand });
    containerEl.querySelector('a').addEventListener('click', () => {
      trackPageSearch('partnershop_redirect_click', this.query, { brand: partnershop.displayBrand, target: partnershop.url });
    });
    this.loadPartnershopProducts(partnershop);
  }

  // Live-Produktkarten vom Partnershop nachladen (via Worker-Proxy, KV-gecacht).
  // Schlaegt der Request fehl oder liefert nichts, bleibt der Text-Banner unveraendert.
  async loadPartnershopProducts(partnershop) {
    let key = '';
    try { key = new URL(partnershop.url).searchParams.get('q') || ''; } catch (e) { /* ignore */ }
    if (!key) return;
    try {
      const resp = await fetch(`https://ai-advisor.markenkoffer.de/partner-products?q=${encodeURIComponent(key)}`);
      if (!resp.ok) return;
      const data = await resp.json();
      const products = (data && data.products) || [];
      const grid = document.getElementById('ts-partnershop-products');
      if (!grid || products.length === 0) return;

      if (data.total && data.min_price) {
        const hintEl = document.getElementById('ts-partnershop-hint');
        if (hintEl) {
          hintEl.textContent = UI.partnershopHintCount
            .replace('{count}', String(data.total))
            .replace('{brand}', partnershop.displayBrand)
            .replace('{price}', this.formatPrice(data.min_price));
        }
      }

      grid.innerHTML = products.map(p => `<a href="${this.escapeHtml(p.url)}" target="_blank" rel="noopener noreferrer"
          style="display:block;background:#fff;border:1px solid #e4e8ed;border-radius:10px;padding:12px 12px 14px;text-align:center;text-decoration:none;color:#1a1a1a;transition:box-shadow .15s;"
          onmouseover="this.style.boxShadow='0 6px 18px rgba(20,30,45,.12)';" onmouseout="this.style.boxShadow='none';">
        <img src="${this.escapeHtml(p.image)}" alt="${this.escapeHtml(p.title)}" style="width:100%;max-width:150px;aspect-ratio:1/1;object-fit:contain;margin-bottom:8px;">
        <div style="font-size:13px;line-height:1.35;">${this.escapeHtml(p.title)}</div>
        <div style="font-weight:600;font-size:14.5px;margin-top:6px;">${this.formatPrice(p.price)}</div>
      </a>`).join('');
      grid.style.display = 'grid';

      const trustEl = document.getElementById('ts-partnershop-trust');
      if (trustEl) trustEl.textContent = UI.partnershopTrust;

      grid.querySelectorAll('a').forEach(a => {
        a.addEventListener('click', () => {
          trackPageSearch('partnershop_product_click', this.query, { brand: partnershop.displayBrand, target: a.href });
        });
      });
    } catch (e) { /* Text-Banner bleibt als Fallback */ }
  }

  async renderNoResultsWithAlternatives(container, facetCounts) {
    const queryLower = this.query.toLowerCase().trim();
    const productWords = new Set(['koffer','trolley','rucksack','tasche','reisekoffer','handgepäck','set','gross','klein','leicht','hartschale','weichgepäck','schulranzen']);
    const qWords = queryLower.split(/\s+/);
    // "Marke nicht geführt" wenn explizit erkannt ODER Query sieht wie Marke aus
    const looksLikeBrand = !!this._notCarriedBrand || (qWords.length <= 2 && !qWords.some(w => productWords.has(w)));
    const displayBrand = this._notCarriedBrand || this.query;

    // If no facets from the zero-result search, fetch popular ones
    let vendorCounts = [];
    let collectionCounts = [];
    const vFacet = facetCounts.find(f => f.field_name === 'vendor');
    const cFacet = facetCounts.find(f => f.field_name === 'product_type');
    if (vFacet) vendorCounts = vFacet.counts.slice(0, 8);
    if (cFacet) collectionCounts = cFacet.counts.filter(c => c.count >= 2).slice(0, 6);

    if (vendorCounts.length === 0) {
      try {
        const baseUrl = `${TS_PAGE.protocol}://${TS_PAGE.host}:${TS_PAGE.port}`;
        const resp = await fetch(`${baseUrl}/multi_search`, {
          method: 'POST',
          headers: { 'X-TYPESENSE-API-KEY': TS_PAGE.searchKey, 'Content-Type': 'application/json' },
          body: JSON.stringify({ searches: [{ collection: TS_PAGE.collection, q: '*', per_page: 0, facet_by: 'vendor,product_type', max_facet_values: 10, filter_by: 'available:true && status:active' }] }),
        });
        const data = await resp.json();
        const fc = data.results[0].facet_counts || [];
        const vf = fc.find(f => f.field_name === 'vendor');
        const cf = fc.find(f => f.field_name === 'product_type');
        if (vf) vendorCounts = vf.counts.slice(0, 8);
        if (cf) collectionCounts = cf.counts.filter(c => c.count >= 2).slice(0, 6);
      } catch (e) { /* silent */ }
    }

    let headerHtml;
    if (looksLikeBrand) {
      const icon = this._notCarriedBrand ? '&#128188;' : '&#128269;';
      headerHtml = `<div style="font-size:42px;line-height:1;margin-bottom:16px;">${icon}</div>
        <h2 style="font-size:22px;font-weight:600;margin:0 0 8px;line-height:1.3;">${UI.brandNotCarried.replace('{brand}', this.escapeHtml(displayBrand))}</h2>
        <p style="color:rgba(0,0,0,.65);margin:0;font-size:15px;">${UI.tryInstead}</p>`;
    } else {
      headerHtml = `<p style="font-size:18px;margin-bottom:8px;">${UI.noResults} \u201e${this.escapeHtml(this.query)}\u201c</p>
        <p style="color:rgba(0,0,0,.6);">${UI.tryInstead}</p>`;
    }

    const _pillStyle = 'display:inline-flex;align-items:center;gap:6px;padding:10px 16px;border:1px solid rgba(0,0,0,.14);border-radius:999px;font-size:14px;font-weight:500;color:inherit;text-decoration:none;background:#fff;transition:all .15s;';
    const _pillHover = "this.style.borderColor='rgba(0,0,0,.35)';this.style.background='#f8f8f8';";
    const _pillOut = "this.style.borderColor='rgba(0,0,0,.14)';this.style.background='#fff';";
    const _headingStyle = 'font-size:13px;font-weight:600;text-transform:uppercase;letter-spacing:0.04em;color:rgba(0,0,0,.55);margin:0 0 14px;';

    let brandsHtml = '';
    if (vendorCounts.length > 0) {
      brandsHtml = `<div style="margin-top:32px;">
        <h3 style="${_headingStyle}">${UI.popularBrands}</h3>
        <div style="display:flex;flex-wrap:wrap;gap:10px;">
          ${vendorCounts.map(v => {
            const slug = v.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            return `<a href="/collections/${slug}" style="${_pillStyle}" onmouseover="${_pillHover}" onmouseout="${_pillOut}">${this.escapeHtml(v.value)}</a>`;
          }).join('')}
        </div></div>`;
    }

    let categoriesHtml = '';
    if (collectionCounts.length > 0) {
      categoriesHtml = `<div style="margin-top:24px;">
        <h3 style="${_headingStyle}">${UI.popularCategories}</h3>
        <div style="display:flex;flex-wrap:wrap;gap:10px;">
          ${collectionCounts.map(c => {
            const slug = c.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
            return `<a href="/search?q=${encodeURIComponent(c.value)}" style="${_pillStyle}" onmouseover="${_pillHover}" onmouseout="${_pillOut}">${this.escapeHtml(c.value)} <span style="color:rgba(0,0,0,.45);font-weight:400;">${c.count}</span></a>`;
          }).join('')}
        </div></div>`;
    }

    // Service-Link (Retoure, Kontakt, Versand)
    const serviceLink = detectServiceLinkPage(this.query);
    let serviceLinkHtml = '';
    if (serviceLink) {
      serviceLinkHtml = `<div style="margin-top:20px;padding:14px 18px;background:#f5f5f5;border-radius:8px;">
        <a href="${serviceLink.url}" style="display:flex;align-items:center;gap:10px;font-weight:600;font-size:16px;color:inherit;text-decoration:none;">
          <span style="font-size:22px;">&#128712;</span> ${this.escapeHtml(serviceLink.label)} &rarr;
        </a>
      </div>`;
    }

    container.innerHTML = `<div style="padding:48px 24px 40px;max-width:720px;margin:0 auto;">${headerHtml}${serviceLinkHtml}${brandsHtml}${categoriesHtml}</div>`;
  }

  revealContent() {
    const skeleton = document.getElementById('ts-skeleton');
    const main = document.getElementById('ts-main-content');
    if (skeleton) skeleton.style.display = 'none';
    if (main) main.style.display = '';
  }

  showShopifyFallback() {
    // Typesense nicht erreichbar: Shopify-Standardergebnisse anzeigen
    const fallback = document.getElementById('ts-shopify-fallback');
    if (fallback) fallback.style.display = 'block';
    // Typesense UI ausblenden
    const container = this.gridEl ? this.gridEl.closest('.collection-container') : null;
    if (container) container.style.display = 'none';
    // KI-Widget und Filter-Bar ausblenden
    const aiWidget = document.getElementById('ts-ai-widget');
    if (aiWidget) aiWidget.style.display = 'none';
    const mobileToggle = document.getElementById('ts-mobile-filter-toggle');
    if (mobileToggle) mobileToggle.style.display = 'none';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  console.log('[TS-SEARCH] DOMContentLoaded, config:', !!document.getElementById('ts-search-config'));
  if (document.getElementById('ts-search-config')) {
    try {
      const page = new TypesenseSearchPage();
      console.log('[TS-SEARCH] Page created, query:', page.query, 'cleanQuery:', page.cleanQuery);
    } catch(e) {
      console.error('[TS-SEARCH] INIT ERROR:', e);
    }
    window.addEventListener('popstate', () => {
      page.parseUrlParams();
      page.search();
    });
  }
});

